'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://rest.ensembl.org/info/assembly/homo_sapiens?content-type=application/json&bands=1
exports.default = {
  genebuild_initial_release_date: '2014-07',
  karyotype: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', 'X', 'Y', 'MT'],
  genebuild_method: 'full_genebuild',
  genebuild_last_geneset_update: '2018-11',
  assembly_date: '2013-12',
  top_level_region: [{ length: 71251, coord_system: 'scaffold', name: 'KI270757.1' }, { name: 'KI270741.1', length: 157432, coord_system: 'scaffold' }, { name: 'KI270756.1', coord_system: 'scaffold', length: 79590 }, { name: 'KI270730.1', length: 112551, coord_system: 'scaffold' }, { length: 73985, coord_system: 'scaffold', name: 'KI270739.1' }, { coord_system: 'scaffold', length: 99375, name: 'KI270738.1' }, { coord_system: 'scaffold', length: 103838, name: 'KI270737.1' }, { name: 'KI270312.1', coord_system: 'scaffold', length: 998 }, { coord_system: 'scaffold', length: 5796, name: 'KI270591.1' }, { length: 2805, coord_system: 'scaffold', name: 'KI270371.1' }, { name: 'KI270385.1', coord_system: 'scaffold', length: 990 }, { length: 1930, coord_system: 'scaffold', name: 'KI270381.1' }, { length: 3253, coord_system: 'scaffold', name: 'KI270517.1' }, { length: 1951, coord_system: 'scaffold', name: 'KI270508.1' }, { length: 993, coord_system: 'scaffold', name: 'KI270539.1' }, { name: 'KI270593.1', length: 3041, coord_system: 'scaffold' }, { name: 'KI270530.1', coord_system: 'scaffold', length: 2168 }, { length: 6158, coord_system: 'scaffold', name: 'KI270588.1' }, { coord_system: 'scaffold', length: 971, name: 'KI270392.1' }, { coord_system: 'scaffold', length: 2378, name: 'KI270375.1' }, { name: 'KI270329.1', length: 1040, coord_system: 'scaffold' }, { length: 1026, coord_system: 'scaffold', name: 'KI270336.1' }, { length: 5353, coord_system: 'scaffold', name: 'KI270507.1' }, { name: 'KI270423.1', coord_system: 'scaffold', length: 981 }, { name: 'KI270382.1', length: 4215, coord_system: 'scaffold' }, { name: 'KI270383.1', coord_system: 'scaffold', length: 1750 }, { length: 4055, coord_system: 'scaffold', name: 'KI270468.1' }, { name: 'KI270379.1', length: 1045, coord_system: 'scaffold' }, { name: 'KI270515.1', length: 6361, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 6504, name: 'KI270582.1' }, { coord_system: 'scaffold', length: 1444, name: 'KI270316.1' }, { name: 'KI270511.1', coord_system: 'scaffold', length: 8127 }, { length: 1233, coord_system: 'scaffold', name: 'KI270466.1' }, { length: 2186, coord_system: 'scaffold', name: 'KI270518.1' }, { name: 'KI270580.1', coord_system: 'scaffold', length: 1553 }, { coord_system: 'scaffold', length: 1428, name: 'KI270340.1' }, { name: 'KI270422.1', coord_system: 'scaffold', length: 1445 }, { coord_system: 'scaffold', length: 4513, name: 'KI270584.1' }, { coord_system: 'scaffold', length: 2983, name: 'KI270528.1' }, { name: 'KI270330.1', coord_system: 'scaffold', length: 1652 }, { name: 'KI270509.1', coord_system: 'scaffold', length: 2318 }, { name: 'KI270587.1', length: 2969, coord_system: 'scaffold' }, { name: 'KI270394.1', length: 970, coord_system: 'scaffold' }, { length: 1048, coord_system: 'scaffold', name: 'KI270335.1' }, { length: 1650, coord_system: 'scaffold', name: 'KI270372.1' }, { length: 1216, coord_system: 'scaffold', name: 'KI270388.1' }, { coord_system: 'scaffold', length: 1201, name: 'KI270310.1' }, { name: 'KI270522.1', length: 5674, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 8320, name: 'KI270366.1' }, { length: 1368, coord_system: 'scaffold', name: 'KI270334.1' }, { length: 1179, coord_system: 'scaffold', name: 'KI270412.1' }, { length: 2274, coord_system: 'scaffold', name: 'KI270302.1' }, { length: 7046, coord_system: 'scaffold', name: 'KI270581.1' }, { name: 'KI270424.1', length: 2140, coord_system: 'scaffold' }, { length: 1599, coord_system: 'scaffold', name: 'KI270548.1' }, { coord_system: 'scaffold', length: 1880, name: 'KI270396.1' }, { name: 'KI270374.1', length: 2656, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 1143, name: 'KI270395.1' }, { length: 1537, coord_system: 'scaffold', name: 'KI270387.1' }, { length: 2145, coord_system: 'scaffold', name: 'KI270418.1' }, { name: 'KI270389.1', length: 1298, coord_system: 'scaffold' }, { length: 1048, coord_system: 'scaffold', name: 'KI270378.1' }, { coord_system: 'scaffold', length: 1029, name: 'KI270419.1' }, { name: 'KI270544.1', coord_system: 'scaffold', length: 1202 }, { name: 'KI270510.1', length: 2415, coord_system: 'scaffold' }, { length: 7992, coord_system: 'scaffold', name: 'KI270448.1' }, { coord_system: 'scaffold', length: 4685, name: 'KI270590.1' }, { name: 'KI270529.1', length: 1899, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 1361, name: 'KI270429.1' }, { name: 'KI270376.1', length: 1136, coord_system: 'scaffold' }, { name: 'KI270362.1', length: 3530, coord_system: 'scaffold' }, { name: 'KI270583.1', coord_system: 'scaffold', length: 1400 }, { name: 'KI270521.1', length: 7642, coord_system: 'scaffold' }, { name: 'KI270305.1', coord_system: 'scaffold', length: 1472 }, { coord_system: 'scaffold', length: 1300, name: 'KI270516.1' }, { length: 1121, coord_system: 'scaffold', name: 'KI270337.1' }, { coord_system: 'scaffold', length: 1884, name: 'KI270425.1' }, { name: 'KI270384.1', coord_system: 'scaffold', length: 1658 }, { name: 'KI270393.1', coord_system: 'scaffold', length: 1308 }, { name: 'KI270373.1', coord_system: 'scaffold', length: 1451 }, { length: 1484, coord_system: 'scaffold', name: 'KI270391.1' }, { name: 'KI270386.1', length: 1788, coord_system: 'scaffold' }, { name: 'KI270338.1', length: 1428, coord_system: 'scaffold' }, { name: 'KI270363.1', coord_system: 'scaffold', length: 1803 }, { coord_system: 'scaffold', length: 91309, name: 'KI270538.1' }, { name: 'KI270467.1', length: 3920, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 1774, name: 'KI270465.1' }, { length: 4416, coord_system: 'scaffold', name: 'KI270320.1' }, { coord_system: 'scaffold', length: 1942, name: 'KI270303.1' }, { name: 'KI270411.1', coord_system: 'scaffold', length: 2646 }, { name: 'KI270315.1', length: 2276, coord_system: 'scaffold' }, { name: 'KI270311.1', length: 12399, coord_system: 'scaffold' }, { name: 'KI270322.1', coord_system: 'scaffold', length: 21476 }, { length: 2699, coord_system: 'scaffold', name: 'KI270333.1' }, { coord_system: 'scaffold', length: 37690, name: 'KI270317.1' }, { name: 'KI270304.1', length: 2165, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 2043, name: 'KI270417.1' }, { name: 'KI270420.1', length: 2321, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 2387, name: 'KI270390.1' }, { name: 'KI270589.1', length: 44474, coord_system: 'scaffold' }, { name: 'KI270414.1', coord_system: 'scaffold', length: 2489 }, { coord_system: 'scaffold', length: 31033, name: 'KI270579.1' }, { coord_system: 'scaffold', length: 2855, name: 'KI270364.1' }, { name: 'KI270442.1', coord_system: 'scaffold', length: 392061 }, { coord_system: 'scaffold', length: 280839, name: 'KI270729.1' }, { name: 'KI270736.1', coord_system: 'scaffold', length: 181920 }, { length: 112505, coord_system: 'scaffold', name: 'KI270438.1' }, { coord_system: 'scaffold', length: 138126, name: 'KI270519.1' }, { name: 'KI270512.1', coord_system: 'scaffold', length: 22689 }, { length: 92983, coord_system: 'scaffold', name: 'KI270435.1' }, { length: 42210, coord_system: 'scaffold', name: 'KI270711.1' }, { name: 'GL000009.2', coord_system: 'scaffold', length: 201709 }, { length: 155397, coord_system: 'scaffold', name: 'GL000221.1' }, { name: 'KI270725.1', length: 172810, coord_system: 'scaffold' }, { name: 'KI270740.1', length: 37240, coord_system: 'scaffold' }, { name: 'KI270751.1', coord_system: 'scaffold', length: 150742 }, { coord_system: 'scaffold', length: 66486, name: 'KI270746.1' }, { name: 'GL000213.1', coord_system: 'scaffold', length: 164239 }, { name: 'KI270744.1', length: 168472, coord_system: 'scaffold' }, { name: 'GL000220.1', length: 161802, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 42811, name: 'KI270735.1' }, { coord_system: 'scaffold', length: 165050, name: 'KI270734.1' }, { name: 'KI270709.1', coord_system: 'scaffold', length: 66860 }, { name: 'KI270748.1', length: 93321, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 41891, name: 'KI270745.1' }, { length: 92689, coord_system: 'scaffold', name: 'GL000208.1' }, { name: 'GL000224.1', length: 179693, coord_system: 'scaffold' }, { name: 'KI270752.1', length: 27745, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 137718, name: 'GL000214.1' }, { length: 186739, coord_system: 'scaffold', name: 'KI270742.1' }, { coord_system: 'scaffold', length: 161471, name: 'KI270715.1' }, { length: 182896, coord_system: 'scaffold', name: 'GL000195.1' }, { length: 62944, coord_system: 'scaffold', name: 'KI270753.1' }, { length: 194050, coord_system: 'scaffold', name: 'KI270722.1' }, { name: 'KI270719.1', length: 176845, coord_system: 'scaffold' }, { length: 36723, coord_system: 'scaffold', name: 'KI270755.1' }, { length: 176043, coord_system: 'scaffold', name: 'KI270712.1' }, { name: 'KI270732.1', length: 41543, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 127682, name: 'KI270708.1' }, { length: 150754, coord_system: 'scaffold', name: 'KI270731.1' }, { length: 39050, coord_system: 'scaffold', name: 'KI270720.1' }, { coord_system: 'scaffold', length: 191469, name: 'GL000194.1' }, { coord_system: 'scaffold', length: 40745, name: 'KI270713.1' }, { coord_system: 'scaffold', length: 153799, name: 'KI270716.1' }, { length: 38115, coord_system: 'scaffold', name: 'KI270723.1' }, { coord_system: 'scaffold', length: 15008, name: 'GL000226.1' }, { length: 179198, coord_system: 'scaffold', name: 'GL000219.1' }, { name: 'KI270750.1', coord_system: 'scaffold', length: 148850 }, { length: 39555, coord_system: 'scaffold', name: 'KI270724.1' }, { name: 'KI270707.1', coord_system: 'scaffold', length: 32032 }, { name: 'KI270754.1', length: 40191, coord_system: 'scaffold' }, { name: 'KI270706.1', length: 175055, coord_system: 'scaffold' }, { length: 161147, coord_system: 'scaffold', name: 'GL000218.1' }, { name: 'KI270714.1', length: 41717, coord_system: 'scaffold' }, { name: 'KI270733.1', length: 179772, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 100316, name: 'KI270721.1' }, { coord_system: 'scaffold', length: 158759, name: 'KI270749.1' }, { length: 176608, coord_system: 'scaffold', name: 'GL000216.2' }, { coord_system: 'scaffold', length: 185591, name: 'GL000205.2' }, { name: 'KI270718.1', length: 38054, coord_system: 'scaffold' }, { length: 40062, coord_system: 'scaffold', name: 'KI270717.1' }, { coord_system: 'scaffold', length: 210658, name: 'KI270743.1' }, { name: 'GL000008.2', length: 209709, coord_system: 'scaffold' }, { coord_system: 'scaffold', length: 40176, name: 'KI270710.1' }, { name: 'GL000225.1', coord_system: 'scaffold', length: 211173 }, { name: 'KI270747.1', coord_system: 'scaffold', length: 198735 }, { length: 43739, coord_system: 'scaffold', name: 'KI270726.1' }, { coord_system: 'scaffold', length: 1872759, name: 'KI270728.1' }, {
    name: 'Y',
    coord_system: 'chromosome',
    bands: [{
      stain: 'acen',
      start: 10300001,
      seq_region_name: 'Y',
      end: 10400000,
      id: 'p11.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 600001,
      seq_region_name: 'Y',
      id: 'p11.2',
      end: 10300000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p11.31',
      end: 600000,
      seq_region_name: 'Y',
      start: 300001,
      stain: 'gpos50'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p11.32',
      end: 300000,
      seq_region_name: 'Y',
      start: 1,
      stain: 'gneg'
    }, {
      stain: 'acen',
      start: 10400001,
      id: 'q11.1',
      end: 10600000,
      seq_region_name: 'Y',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: 'Y',
      id: 'q11.21',
      end: 12400000,
      stain: 'gneg',
      start: 10600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos50',
      start: 12400001,
      seq_region_name: 'Y',
      id: 'q11.221',
      end: 17100000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: 'Y',
      id: 'q11.222',
      end: 19600000,
      stain: 'gneg',
      start: 17100001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 23800000,
      id: 'q11.223',
      seq_region_name: 'Y',
      stain: 'gpos50',
      start: 19600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q11.23',
      end: 26600000,
      seq_region_name: 'Y',
      stain: 'gneg',
      start: 23800001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q12',
      end: 57227415,
      seq_region_name: 'Y',
      stain: 'gvar',
      start: 26600001,
      assembly_name: 'GRCh38',
      strand: 0
    }],
    length: 57227415
  }, {
    length: 64444167,
    bands: [{
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p11.1',
      end: 28100000,
      seq_region_name: '20',
      start: 25700001,
      stain: 'acen'
    }, {
      stain: 'gneg',
      start: 22300001,
      seq_region_name: '20',
      end: 25700000,
      id: 'p11.21',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p11.22',
      end: 22300000,
      seq_region_name: '20',
      stain: 'gpos25',
      start: 21300001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '20',
      id: 'p11.23',
      end: 21300000,
      start: 17900001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 12000001,
      end: 17900000,
      id: 'p12.1',
      seq_region_name: '20'
    }, {
      stain: 'gneg',
      start: 9200001,
      end: 12000000,
      id: 'p12.2',
      seq_region_name: '20',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 5100001,
      stain: 'gpos75',
      seq_region_name: '20',
      id: 'p12.3',
      end: 9200000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p13',
      end: 5100000,
      seq_region_name: '20',
      stain: 'gneg',
      start: 1,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 28100001,
      stain: 'acen',
      seq_region_name: '20',
      id: 'q11.1',
      end: 30400000
    }, {
      seq_region_name: '20',
      end: 33500000,
      id: 'q11.21',
      start: 30400001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 35800000,
      id: 'q11.22',
      seq_region_name: '20',
      stain: 'gpos25',
      start: 33500001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 35800001,
      stain: 'gneg',
      seq_region_name: '20',
      end: 39000000,
      id: 'q11.23'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 39000001,
      stain: 'gpos75',
      seq_region_name: '20',
      id: 'q12',
      end: 43100000
    }, {
      seq_region_name: '20',
      id: 'q13.11',
      end: 43500000,
      start: 43100001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q13.12',
      end: 47800000,
      seq_region_name: '20',
      start: 43500001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '20',
      end: 51200000,
      id: 'q13.13',
      start: 47800001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 51200001,
      stain: 'gpos75',
      seq_region_name: '20',
      end: 56400000,
      id: 'q13.2'
    }, {
      id: 'q13.31',
      end: 57800000,
      seq_region_name: '20',
      stain: 'gneg',
      start: 56400001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q13.32',
      end: 59700000,
      seq_region_name: '20',
      start: 57800001,
      stain: 'gpos50'
    }, {
      stain: 'gneg',
      start: 59700001,
      id: 'q13.33',
      end: 64444167,
      seq_region_name: '20',
      assembly_name: 'GRCh38',
      strand: 0
    }],
    coord_system: 'chromosome',
    name: '20'
  }, {
    name: 'X',
    length: 156040895,
    bands: [{
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p11.1',
      end: 61000000,
      seq_region_name: 'X',
      start: 58100001,
      stain: 'acen'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p11.21',
      end: 58100000,
      seq_region_name: 'X',
      start: 54800001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 50100001,
      end: 54800000,
      id: 'p11.22',
      seq_region_name: 'X'
    }, {
      start: 47600001,
      stain: 'gneg',
      id: 'p11.23',
      end: 50100000,
      seq_region_name: 'X',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 42500001,
      stain: 'gpos75',
      id: 'p11.3',
      end: 47600000,
      seq_region_name: 'X',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 37800001,
      id: 'p11.4',
      end: 42500000,
      seq_region_name: 'X',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos100',
      start: 31500001,
      end: 37800000,
      id: 'p21.1',
      seq_region_name: 'X',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 31500000,
      id: 'p21.2',
      seq_region_name: 'X',
      stain: 'gneg',
      start: 29300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: 'X',
      end: 29300000,
      id: 'p21.3',
      start: 24900001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 24900000,
      id: 'p22.11',
      seq_region_name: 'X',
      start: 21900001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 19200001,
      stain: 'gpos50',
      id: 'p22.12',
      end: 21900000,
      seq_region_name: 'X'
    }, {
      id: 'p22.13',
      end: 19200000,
      seq_region_name: 'X',
      start: 17400001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 17400000,
      id: 'p22.2',
      seq_region_name: 'X',
      start: 9600001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: 'X',
      id: 'p22.31',
      end: 9600000,
      stain: 'gneg',
      start: 6100001
    }, {
      stain: 'gpos50',
      start: 4400001,
      seq_region_name: 'X',
      id: 'p22.32',
      end: 6100000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p22.33',
      end: 4400000,
      seq_region_name: 'X',
      stain: 'gneg',
      start: 1
    }, {
      stain: 'acen',
      start: 61000001,
      seq_region_name: 'X',
      id: 'q11.1',
      end: 63800000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 63800001,
      stain: 'gneg',
      id: 'q11.2',
      end: 65400000,
      seq_region_name: 'X',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 65400001,
      stain: 'gpos50',
      seq_region_name: 'X',
      end: 68500000,
      id: 'q12',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 68500001,
      stain: 'gneg',
      seq_region_name: 'X',
      id: 'q13.1',
      end: 73000000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 73000001,
      stain: 'gpos50',
      end: 74700000,
      id: 'q13.2',
      seq_region_name: 'X'
    }, {
      start: 74700001,
      stain: 'gneg',
      seq_region_name: 'X',
      id: 'q13.3',
      end: 76800000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos100',
      start: 76800001,
      seq_region_name: 'X',
      id: 'q21.1',
      end: 85400000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: 'X',
      id: 'q21.2',
      end: 87000000,
      start: 85400001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 87000001,
      stain: 'gpos100',
      seq_region_name: 'X',
      end: 92700000,
      id: 'q21.31'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: 'X',
      id: 'q21.32',
      end: 94300000,
      stain: 'gneg',
      start: 92700001
    }, {
      start: 94300001,
      stain: 'gpos75',
      id: 'q21.33',
      end: 99100000,
      seq_region_name: 'X',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 99100001,
      stain: 'gneg',
      end: 103300000,
      id: 'q22.1',
      seq_region_name: 'X',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 103300001,
      stain: 'gpos50',
      seq_region_name: 'X',
      end: 104500000,
      id: 'q22.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 104500001,
      seq_region_name: 'X',
      end: 109400000,
      id: 'q22.3'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: 'X',
      id: 'q23',
      end: 117400000,
      stain: 'gpos75',
      start: 109400001
    }, {
      stain: 'gneg',
      start: 117400001,
      id: 'q24',
      end: 121800000,
      seq_region_name: 'X',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos100',
      start: 121800001,
      seq_region_name: 'X',
      id: 'q25',
      end: 129500000
    }, {
      id: 'q26.1',
      end: 131300000,
      seq_region_name: 'X',
      stain: 'gneg',
      start: 129500001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: 'X',
      id: 'q26.2',
      end: 134500000,
      start: 131300001,
      stain: 'gpos25'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 138900000,
      id: 'q26.3',
      seq_region_name: 'X',
      start: 134500001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 138900001,
      seq_region_name: 'X',
      end: 141200000,
      id: 'q27.1'
    }, {
      end: 143000000,
      id: 'q27.2',
      seq_region_name: 'X',
      start: 141200001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 148000000,
      id: 'q27.3',
      seq_region_name: 'X',
      stain: 'gpos100',
      start: 143000001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q28',
      end: 156040895,
      seq_region_name: 'X',
      stain: 'gneg',
      start: 148000001,
      assembly_name: 'GRCh38',
      strand: 0
    }],
    coord_system: 'chromosome'
  }, {
    coord_system: 'chromosome',
    bands: [{
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '13',
      id: 'p11.1',
      end: 17700000,
      stain: 'acen',
      start: 16500001
    }, {
      seq_region_name: '13',
      id: 'p11.2',
      end: 16500000,
      stain: 'gvar',
      start: 10100001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '13',
      id: 'p12',
      end: 10100000,
      stain: 'stalk',
      start: 4600001
    }, {
      end: 4600000,
      id: 'p13',
      seq_region_name: '13',
      stain: 'gvar',
      start: 1,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 17700001,
      stain: 'acen',
      id: 'q11',
      end: 18900000,
      seq_region_name: '13'
    }, {
      stain: 'gneg',
      start: 18900001,
      seq_region_name: '13',
      id: 'q12.11',
      end: 22600000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '13',
      end: 24900000,
      id: 'q12.12',
      stain: 'gpos25',
      start: 22600001
    }, {
      start: 24900001,
      stain: 'gneg',
      seq_region_name: '13',
      end: 27200000,
      id: 'q12.13',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 27200001,
      stain: 'gpos25',
      seq_region_name: '13',
      id: 'q12.2',
      end: 28300000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 28300001,
      stain: 'gneg',
      seq_region_name: '13',
      end: 31600000,
      id: 'q12.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '13',
      end: 33400000,
      id: 'q13.1',
      start: 31600001,
      stain: 'gpos50',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 33400001,
      stain: 'gneg',
      seq_region_name: '13',
      id: 'q13.2',
      end: 34900000
    }, {
      stain: 'gpos75',
      start: 34900001,
      seq_region_name: '13',
      id: 'q13.3',
      end: 39500000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q14.11',
      end: 44600000,
      seq_region_name: '13',
      start: 39500001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q14.12',
      end: 45200000,
      seq_region_name: '13',
      stain: 'gpos25',
      start: 44600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 45200001,
      seq_region_name: '13',
      id: 'q14.13',
      end: 46700000
    }, {
      start: 46700001,
      stain: 'gpos50',
      seq_region_name: '13',
      id: 'q14.2',
      end: 50300000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 50300001,
      seq_region_name: '13',
      id: 'q14.3',
      end: 54700000
    }, {
      seq_region_name: '13',
      id: 'q21.1',
      end: 59000000,
      stain: 'gpos100',
      start: 54700001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '13',
      end: 61800000,
      id: 'q21.2',
      start: 59000001,
      stain: 'gneg'
    }, {
      stain: 'gpos75',
      start: 61800001,
      end: 65200000,
      id: 'q21.31',
      seq_region_name: '13',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 68100000,
      id: 'q21.32',
      seq_region_name: '13',
      stain: 'gneg',
      start: 65200001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 68100001,
      stain: 'gpos100',
      end: 72800000,
      id: 'q21.33',
      seq_region_name: '13'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 72800001,
      stain: 'gneg',
      seq_region_name: '13',
      end: 74900000,
      id: 'q22.1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 74900001,
      seq_region_name: '13',
      end: 76700000,
      id: 'q22.2'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 76700001,
      seq_region_name: '13',
      end: 78500000,
      id: 'q22.3'
    }, {
      id: 'q31.1',
      end: 87100000,
      seq_region_name: '13',
      start: 78500001,
      stain: 'gpos100',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '13',
      end: 89400000,
      id: 'q31.2',
      start: 87100001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '13',
      end: 94400000,
      id: 'q31.3',
      stain: 'gpos100',
      start: 89400001
    }, {
      stain: 'gneg',
      start: 94400001,
      seq_region_name: '13',
      id: 'q32.1',
      end: 97500000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 97500001,
      stain: 'gpos25',
      seq_region_name: '13',
      id: 'q32.2',
      end: 98700000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '13',
      id: 'q32.3',
      end: 101100000,
      start: 98700001,
      stain: 'gneg'
    }, {
      start: 101100001,
      stain: 'gpos100',
      seq_region_name: '13',
      id: 'q33.1',
      end: 104200000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q33.2',
      end: 106400000,
      seq_region_name: '13',
      stain: 'gneg',
      start: 104200001
    }, {
      start: 106400001,
      stain: 'gpos100',
      end: 109600000,
      id: 'q33.3',
      seq_region_name: '13',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q34',
      end: 114364328,
      seq_region_name: '13',
      start: 109600001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }],
    length: 114364328,
    name: '13'
  }, {
    name: '22',
    bands: [{
      id: 'p11.1',
      end: 15000000,
      seq_region_name: '22',
      stain: 'acen',
      start: 13700001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gvar',
      start: 9400001,
      seq_region_name: '22',
      end: 13700000,
      id: 'p11.2'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 4300001,
      stain: 'stalk',
      end: 9400000,
      id: 'p12',
      seq_region_name: '22'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '22',
      id: 'p13',
      end: 4300000,
      stain: 'gvar',
      start: 1
    }, {
      start: 15000001,
      stain: 'acen',
      end: 17400000,
      id: 'q11.1',
      seq_region_name: '22',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 17400001,
      seq_region_name: '22',
      end: 21700000,
      id: 'q11.21',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 21700001,
      seq_region_name: '22',
      end: 23100000,
      id: 'q11.22'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 23100001,
      seq_region_name: '22',
      end: 25500000,
      id: 'q11.23'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 25500001,
      stain: 'gpos50',
      seq_region_name: '22',
      id: 'q12.1',
      end: 29200000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 29200001,
      stain: 'gneg',
      seq_region_name: '22',
      id: 'q12.2',
      end: 31800000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 31800001,
      id: 'q12.3',
      end: 37200000,
      seq_region_name: '22'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 37200001,
      seq_region_name: '22',
      id: 'q13.1',
      end: 40600000
    }, {
      seq_region_name: '22',
      end: 43800000,
      id: 'q13.2',
      start: 40600001,
      stain: 'gpos50',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 43800001,
      seq_region_name: '22',
      id: 'q13.31',
      end: 48100000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '22',
      id: 'q13.32',
      end: 49100000,
      stain: 'gpos50',
      start: 48100001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q13.33',
      end: 50818468,
      seq_region_name: '22',
      start: 49100001,
      stain: 'gneg'
    }],
    coord_system: 'chromosome',
    length: 50818468
  }, {
    name: '10',
    coord_system: 'chromosome',
    bands: [{
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '10',
      id: 'p11.1',
      end: 39800000,
      start: 38000001,
      stain: 'acen'
    }, {
      seq_region_name: '10',
      end: 38000000,
      id: 'p11.21',
      start: 34200001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '10',
      id: 'p11.22',
      end: 34200000,
      start: 31100001,
      stain: 'gpos25'
    }, {
      stain: 'gneg',
      start: 29300001,
      seq_region_name: '10',
      id: 'p11.23',
      end: 31100000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p12.1',
      end: 29300000,
      seq_region_name: '10',
      stain: 'gpos50',
      start: 24300001
    }, {
      stain: 'gneg',
      start: 22300001,
      id: 'p12.2',
      end: 24300000,
      seq_region_name: '10',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 18400001,
      stain: 'gpos75',
      seq_region_name: '10',
      id: 'p12.31',
      end: 22300000
    }, {
      stain: 'gneg',
      start: 18300001,
      seq_region_name: '10',
      id: 'p12.32',
      end: 18400000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 17300001,
      stain: 'gpos75',
      seq_region_name: '10',
      end: 18300000,
      id: 'p12.33',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p13',
      end: 17300000,
      seq_region_name: '10',
      stain: 'gneg',
      start: 12200001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 6600001,
      stain: 'gpos75',
      id: 'p14',
      end: 12200000,
      seq_region_name: '10'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '10',
      end: 6600000,
      id: 'p15.1',
      stain: 'gneg',
      start: 3800001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '10',
      end: 3800000,
      id: 'p15.2',
      start: 3000001,
      stain: 'gpos25'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '10',
      id: 'p15.3',
      end: 3000000,
      start: 1,
      stain: 'gneg'
    }, {
      seq_region_name: '10',
      id: 'q11.1',
      end: 41600000,
      start: 39800001,
      stain: 'acen',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 41600001,
      stain: 'gneg',
      end: 45500000,
      id: 'q11.21',
      seq_region_name: '10',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos25',
      start: 45500001,
      id: 'q11.22',
      end: 48600000,
      seq_region_name: '10',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '10',
      id: 'q11.23',
      end: 51100000,
      stain: 'gneg',
      start: 48600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q21.1',
      end: 59400000,
      seq_region_name: '10',
      stain: 'gpos100',
      start: 51100001
    }, {
      seq_region_name: '10',
      id: 'q21.2',
      end: 62800000,
      stain: 'gneg',
      start: 59400001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos100',
      start: 62800001,
      seq_region_name: '10',
      end: 68800000,
      id: 'q21.3'
    }, {
      end: 73100000,
      id: 'q22.1',
      seq_region_name: '10',
      start: 68800001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos50',
      start: 73100001,
      id: 'q22.2',
      end: 75900000,
      seq_region_name: '10',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q22.3',
      end: 80300000,
      seq_region_name: '10',
      start: 75900001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 80300001,
      stain: 'gpos100',
      id: 'q23.1',
      end: 86100000,
      seq_region_name: '10'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 86100001,
      stain: 'gneg',
      seq_region_name: '10',
      end: 87700000,
      id: 'q23.2'
    }, {
      stain: 'gpos75',
      start: 87700001,
      seq_region_name: '10',
      end: 91100000,
      id: 'q23.31',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 91100001,
      seq_region_name: '10',
      end: 92300000,
      id: 'q23.32'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 92300001,
      stain: 'gpos50',
      seq_region_name: '10',
      id: 'q23.33',
      end: 95300000
    }, {
      start: 95300001,
      stain: 'gneg',
      seq_region_name: '10',
      end: 97500000,
      id: 'q24.1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 97500001,
      stain: 'gpos50',
      seq_region_name: '10',
      id: 'q24.2',
      end: 100100000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 100100001,
      end: 101200000,
      id: 'q24.31',
      seq_region_name: '10'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '10',
      id: 'q24.32',
      end: 103100000,
      stain: 'gpos25',
      start: 101200001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 104000000,
      id: 'q24.33',
      seq_region_name: '10',
      stain: 'gneg',
      start: 103100001
    }, {
      start: 104000001,
      stain: 'gpos100',
      seq_region_name: '10',
      id: 'q25.1',
      end: 110100000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q25.2',
      end: 113100000,
      seq_region_name: '10',
      start: 110100001,
      stain: 'gneg'
    }, {
      stain: 'gpos75',
      start: 113100001,
      id: 'q25.3',
      end: 117300000,
      seq_region_name: '10',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 117300001,
      stain: 'gneg',
      id: 'q26.11',
      end: 119900000,
      seq_region_name: '10'
    }, {
      start: 119900001,
      stain: 'gpos50',
      seq_region_name: '10',
      end: 121400000,
      id: 'q26.12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 121400001,
      stain: 'gneg',
      end: 125700000,
      id: 'q26.13',
      seq_region_name: '10'
    }, {
      end: 128800000,
      id: 'q26.2',
      seq_region_name: '10',
      start: 125700001,
      stain: 'gpos50',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '10',
      end: 133797422,
      id: 'q26.3',
      stain: 'gneg',
      start: 128800001
    }],
    length: 133797422
  }, {
    bands: [{
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '6',
      end: 59800000,
      id: 'p11.1',
      start: 58500001,
      stain: 'acen'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '6',
      id: 'p11.2',
      end: 58500000,
      stain: 'gneg',
      start: 57200001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos100',
      start: 53000001,
      seq_region_name: '6',
      id: 'p12.1',
      end: 57200000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '6',
      id: 'p12.2',
      end: 53000000,
      start: 51800001,
      stain: 'gneg'
    }, {
      stain: 'gpos100',
      start: 46200001,
      id: 'p12.3',
      end: 51800000,
      seq_region_name: '6',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 40500001,
      stain: 'gneg',
      end: 46200000,
      id: 'p21.1',
      seq_region_name: '6'
    }, {
      stain: 'gpos25',
      start: 36600001,
      id: 'p21.2',
      end: 40500000,
      seq_region_name: '6',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '6',
      id: 'p21.31',
      end: 36600000,
      stain: 'gneg',
      start: 33500001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p21.32',
      end: 33500000,
      seq_region_name: '6',
      start: 32100001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 30500001,
      stain: 'gneg',
      end: 32100000,
      id: 'p21.33',
      seq_region_name: '6'
    }, {
      end: 30500000,
      id: 'p22.1',
      seq_region_name: '6',
      stain: 'gpos50',
      start: 27100001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 27100000,
      id: 'p22.2',
      seq_region_name: '6',
      stain: 'gneg',
      start: 25200001
    }, {
      id: 'p22.3',
      end: 25200000,
      seq_region_name: '6',
      start: 15200001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '6',
      end: 15200000,
      id: 'p23',
      start: 13400001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 11600001,
      end: 13400000,
      id: 'p24.1',
      seq_region_name: '6'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 10600001,
      seq_region_name: '6',
      id: 'p24.2',
      end: 11600000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '6',
      id: 'p24.3',
      end: 10600000,
      start: 7100001,
      stain: 'gpos50'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p25.1',
      end: 7100000,
      seq_region_name: '6',
      start: 4200001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 2300001,
      id: 'p25.2',
      end: 4200000,
      seq_region_name: '6'
    }, {
      start: 1,
      stain: 'gneg',
      seq_region_name: '6',
      end: 2300000,
      id: 'p25.3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 62600000,
      id: 'q11.1',
      seq_region_name: '6',
      start: 59800001,
      stain: 'acen',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 62600001,
      seq_region_name: '6',
      id: 'q11.2',
      end: 62700000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q12',
      end: 69200000,
      seq_region_name: '6',
      start: 62700001,
      stain: 'gpos100'
    }, {
      start: 69200001,
      stain: 'gneg',
      end: 75200000,
      id: 'q13',
      seq_region_name: '6',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 83200000,
      id: 'q14.1',
      seq_region_name: '6',
      stain: 'gpos50',
      start: 75200001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 83200001,
      stain: 'gneg',
      id: 'q14.2',
      end: 84200000,
      seq_region_name: '6',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 87300000,
      id: 'q14.3',
      seq_region_name: '6',
      start: 84200001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 87300001,
      stain: 'gneg',
      id: 'q15',
      end: 92500000,
      seq_region_name: '6'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 98900000,
      id: 'q16.1',
      seq_region_name: '6',
      start: 92500001,
      stain: 'gpos100'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 98900001,
      stain: 'gneg',
      seq_region_name: '6',
      end: 100000000,
      id: 'q16.2'
    }, {
      id: 'q16.3',
      end: 105000000,
      seq_region_name: '6',
      start: 100000001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 105000001,
      stain: 'gneg',
      seq_region_name: '6',
      id: 'q21',
      end: 114200000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 117900000,
      id: 'q22.1',
      seq_region_name: '6',
      start: 114200001,
      stain: 'gpos75'
    }, {
      start: 117900001,
      stain: 'gneg',
      end: 118100000,
      id: 'q22.2',
      seq_region_name: '6',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos100',
      start: 118100001,
      seq_region_name: '6',
      id: 'q22.31',
      end: 125800000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '6',
      id: 'q22.32',
      end: 126800000,
      start: 125800001,
      stain: 'gneg'
    }, {
      seq_region_name: '6',
      end: 130000000,
      id: 'q22.33',
      stain: 'gpos75',
      start: 126800001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 130000001,
      seq_region_name: '6',
      end: 130900000,
      id: 'q23.1'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '6',
      id: 'q23.2',
      end: 134700000,
      stain: 'gpos50',
      start: 130900001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 134700001,
      stain: 'gneg',
      id: 'q23.3',
      end: 138300000,
      seq_region_name: '6'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos75',
      start: 138300001,
      seq_region_name: '6',
      end: 142200000,
      id: 'q24.1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 142200001,
      stain: 'gneg',
      seq_region_name: '6',
      id: 'q24.2',
      end: 145100000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 145100001,
      id: 'q24.3',
      end: 148500000,
      seq_region_name: '6'
    }, {
      start: 148500001,
      stain: 'gneg',
      seq_region_name: '6',
      end: 152100000,
      id: 'q25.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 152100001,
      stain: 'gpos50',
      seq_region_name: '6',
      id: 'q25.2',
      end: 155200000
    }, {
      id: 'q25.3',
      end: 160600000,
      seq_region_name: '6',
      start: 155200001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 164100000,
      id: 'q26',
      seq_region_name: '6',
      start: 160600001,
      stain: 'gpos50',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q27',
      end: 170805979,
      seq_region_name: '6',
      stain: 'gneg',
      start: 164100001
    }],
    coord_system: 'chromosome',
    length: 170805979,
    name: '6'
  }, {
    name: '19',
    bands: [{
      id: 'p11',
      end: 26200000,
      seq_region_name: '19',
      start: 24200001,
      stain: 'acen',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 24200000,
      id: 'p12',
      seq_region_name: '19',
      start: 19900001,
      stain: 'gvar'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 16100001,
      stain: 'gneg',
      seq_region_name: '19',
      end: 19900000,
      id: 'p13.11'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '19',
      end: 16100000,
      id: 'p13.12',
      stain: 'gpos25',
      start: 13800001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 12600001,
      stain: 'gneg',
      end: 13800000,
      id: 'p13.13',
      seq_region_name: '19'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p13.2',
      end: 12600000,
      seq_region_name: '19',
      stain: 'gpos25',
      start: 6900001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 1,
      stain: 'gneg',
      seq_region_name: '19',
      end: 6900000,
      id: 'p13.3'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 26200001,
      stain: 'acen',
      id: 'q11',
      end: 28100000,
      seq_region_name: '19'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gvar',
      start: 28100001,
      seq_region_name: '19',
      id: 'q12',
      end: 31900000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 31900001,
      stain: 'gneg',
      end: 35100000,
      id: 'q13.11',
      seq_region_name: '19'
    }, {
      start: 35100001,
      stain: 'gpos25',
      seq_region_name: '19',
      id: 'q13.12',
      end: 37800000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q13.13',
      end: 38200000,
      seq_region_name: '19',
      stain: 'gneg',
      start: 37800001
    }, {
      seq_region_name: '19',
      end: 42900000,
      id: 'q13.2',
      stain: 'gpos25',
      start: 38200001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 44700000,
      id: 'q13.31',
      seq_region_name: '19',
      start: 42900001,
      stain: 'gneg'
    }, {
      stain: 'gpos25',
      start: 44700001,
      seq_region_name: '19',
      end: 47500000,
      id: 'q13.32',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 47500001,
      end: 50900000,
      id: 'q13.33',
      seq_region_name: '19'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q13.41',
      end: 53100000,
      seq_region_name: '19',
      stain: 'gpos25',
      start: 50900001
    }, {
      seq_region_name: '19',
      end: 55800000,
      id: 'q13.42',
      stain: 'gneg',
      start: 53100001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '19',
      id: 'q13.43',
      end: 58617616,
      stain: 'gpos25',
      start: 55800001
    }],
    coord_system: 'chromosome',
    length: 58617616
  }, {
    length: 107043718,
    coord_system: 'chromosome',
    bands: [{
      stain: 'acen',
      start: 16100001,
      end: 17200000,
      id: 'p11.1',
      seq_region_name: '14',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gvar',
      start: 8000001,
      id: 'p11.2',
      end: 16100000,
      seq_region_name: '14'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p12',
      end: 8000000,
      seq_region_name: '14',
      stain: 'stalk',
      start: 3600001
    }, {
      end: 3600000,
      id: 'p13',
      seq_region_name: '14',
      start: 1,
      stain: 'gvar',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'acen',
      start: 17200001,
      end: 18200000,
      id: 'q11.1',
      seq_region_name: '14'
    }, {
      start: 18200001,
      stain: 'gneg',
      seq_region_name: '14',
      id: 'q11.2',
      end: 24100000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '14',
      end: 32900000,
      id: 'q12',
      start: 24100001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 32900001,
      end: 34800000,
      id: 'q13.1',
      seq_region_name: '14',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 36100000,
      id: 'q13.2',
      seq_region_name: '14',
      start: 34800001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 36100001,
      end: 37400000,
      id: 'q13.3',
      seq_region_name: '14',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 43000000,
      id: 'q21.1',
      seq_region_name: '14',
      start: 37400001,
      stain: 'gpos100'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '14',
      id: 'q21.2',
      end: 46700000,
      stain: 'gneg',
      start: 43000001
    }, {
      end: 50400000,
      id: 'q21.3',
      seq_region_name: '14',
      start: 46700001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '14',
      id: 'q22.1',
      end: 53600000,
      stain: 'gneg',
      start: 50400001
    }, {
      end: 55000000,
      id: 'q22.2',
      seq_region_name: '14',
      stain: 'gpos25',
      start: 53600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '14',
      id: 'q22.3',
      end: 57600000,
      stain: 'gneg',
      start: 55000001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos75',
      start: 57600001,
      seq_region_name: '14',
      id: 'q23.1',
      end: 61600000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q23.2',
      end: 64300000,
      seq_region_name: '14',
      stain: 'gneg',
      start: 61600001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 64300001,
      stain: 'gpos50',
      seq_region_name: '14',
      end: 67400000,
      id: 'q23.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 67400001,
      stain: 'gneg',
      seq_region_name: '14',
      end: 69800000,
      id: 'q24.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '14',
      end: 73300000,
      id: 'q24.2',
      stain: 'gpos50',
      start: 69800001
    }, {
      stain: 'gneg',
      start: 73300001,
      id: 'q24.3',
      end: 78800000,
      seq_region_name: '14',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '14',
      end: 83100000,
      id: 'q31.1',
      stain: 'gpos100',
      start: 78800001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 83100001,
      stain: 'gneg',
      end: 84400000,
      id: 'q31.2',
      seq_region_name: '14',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos100',
      start: 84400001,
      end: 89300000,
      id: 'q31.3',
      seq_region_name: '14'
    }, {
      seq_region_name: '14',
      id: 'q32.11',
      end: 91400000,
      stain: 'gneg',
      start: 89300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 91400001,
      seq_region_name: '14',
      end: 94200000,
      id: 'q32.12'
    }, {
      stain: 'gneg',
      start: 94200001,
      seq_region_name: '14',
      id: 'q32.13',
      end: 95800000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 95800001,
      stain: 'gpos50',
      seq_region_name: '14',
      id: 'q32.2',
      end: 100900000
    }, {
      seq_region_name: '14',
      end: 102700000,
      id: 'q32.31',
      stain: 'gneg',
      start: 100900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '14',
      id: 'q32.32',
      end: 103500000,
      stain: 'gpos50',
      start: 102700001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '14',
      end: 107043718,
      id: 'q32.33',
      stain: 'gneg',
      start: 103500001
    }],
    name: '14'
  }, {
    length: 80373285,
    bands: [{
      seq_region_name: '18',
      id: 'p11.1',
      end: 18500000,
      start: 15400001,
      stain: 'acen',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 10900001,
      stain: 'gneg',
      seq_region_name: '18',
      end: 15400000,
      id: 'p11.21',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 8500001,
      stain: 'gpos25',
      end: 10900000,
      id: 'p11.22',
      seq_region_name: '18',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 7200001,
      stain: 'gneg',
      id: 'p11.23',
      end: 8500000,
      seq_region_name: '18'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 2900001,
      end: 7200000,
      id: 'p11.31',
      seq_region_name: '18'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 1,
      id: 'p11.32',
      end: 2900000,
      seq_region_name: '18'
    }, {
      stain: 'acen',
      start: 18500001,
      seq_region_name: '18',
      id: 'q11.1',
      end: 21500000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 21500001,
      id: 'q11.2',
      end: 27500000,
      seq_region_name: '18'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '18',
      id: 'q12.1',
      end: 35100000,
      stain: 'gpos100',
      start: 27500001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 35100001,
      end: 39500000,
      id: 'q12.2',
      seq_region_name: '18'
    }, {
      id: 'q12.3',
      end: 45900000,
      seq_region_name: '18',
      start: 39500001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '18',
      end: 50700000,
      id: 'q21.1',
      stain: 'gneg',
      start: 45900001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q21.2',
      end: 56200000,
      seq_region_name: '18',
      stain: 'gpos75',
      start: 50700001
    }, {
      seq_region_name: '18',
      end: 58600000,
      id: 'q21.31',
      stain: 'gneg',
      start: 56200001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 58600001,
      stain: 'gpos50',
      id: 'q21.32',
      end: 61300000,
      seq_region_name: '18',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 61300001,
      id: 'q21.33',
      end: 63900000,
      seq_region_name: '18',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q22.1',
      end: 69100000,
      seq_region_name: '18',
      start: 63900001,
      stain: 'gpos100'
    }, {
      seq_region_name: '18',
      end: 71000000,
      id: 'q22.2',
      start: 69100001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos25',
      start: 71000001,
      seq_region_name: '18',
      end: 75400000,
      id: 'q22.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '18',
      id: 'q23',
      end: 80373285,
      start: 75400001,
      stain: 'gneg'
    }],
    coord_system: 'chromosome',
    name: '18'
  }, {
    name: '2',
    length: 242193529,
    bands: [{
      stain: 'acen',
      start: 91800001,
      seq_region_name: '2',
      end: 93900000,
      id: 'p11.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 83100001,
      stain: 'gneg',
      end: 91800000,
      id: 'p11.2',
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos100',
      start: 74800001,
      end: 83100000,
      id: 'p12',
      seq_region_name: '2',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '2',
      id: 'p13.1',
      end: 74800000,
      stain: 'gneg',
      start: 73300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 73300000,
      id: 'p13.2',
      seq_region_name: '2',
      start: 71300001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 68400001,
      id: 'p13.3',
      end: 71300000,
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '2',
      id: 'p14',
      end: 68400000,
      start: 63900001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '2',
      end: 63900000,
      id: 'p15',
      start: 61000001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 54700001,
      stain: 'gpos100',
      seq_region_name: '2',
      id: 'p16.1',
      end: 61000000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      id: 'p16.2',
      end: 54700000,
      stain: 'gneg',
      start: 52600001
    }, {
      start: 47500001,
      stain: 'gpos100',
      seq_region_name: '2',
      end: 52600000,
      id: 'p16.3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '2',
      id: 'p21',
      end: 47500000,
      start: 41500001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      id: 'p22.1',
      end: 41500000,
      stain: 'gpos50',
      start: 38300001
    }, {
      stain: 'gneg',
      start: 36300001,
      end: 38300000,
      id: 'p22.2',
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 36300000,
      id: 'p22.3',
      seq_region_name: '2',
      stain: 'gpos75',
      start: 31800001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 29800001,
      end: 31800000,
      id: 'p23.1',
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 27700001,
      stain: 'gpos25',
      seq_region_name: '2',
      id: 'p23.2',
      end: 29800000
    }, {
      seq_region_name: '2',
      id: 'p23.3',
      end: 27700000,
      start: 23800001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '2',
      id: 'p24.1',
      end: 23800000,
      start: 19000001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      end: 19000000,
      id: 'p24.2',
      start: 16500001,
      stain: 'gneg'
    }, {
      id: 'p24.3',
      end: 16500000,
      seq_region_name: '2',
      stain: 'gpos75',
      start: 12000001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 6900001,
      stain: 'gneg',
      seq_region_name: '2',
      id: 'p25.1',
      end: 12000000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 4400001,
      stain: 'gpos50',
      seq_region_name: '2',
      end: 6900000,
      id: 'p25.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      id: 'p25.3',
      end: 4400000,
      stain: 'gneg',
      start: 1
    }, {
      start: 93900001,
      stain: 'acen',
      seq_region_name: '2',
      end: 96000000,
      id: 'q11.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 96000001,
      end: 102100000,
      id: 'q11.2',
      seq_region_name: '2'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '2',
      id: 'q12.1',
      end: 105300000,
      start: 102100001,
      stain: 'gpos50'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '2',
      end: 106700000,
      id: 'q12.2',
      stain: 'gneg',
      start: 105300001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos25',
      start: 106700001,
      seq_region_name: '2',
      id: 'q12.3',
      end: 108700000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 108700001,
      id: 'q13',
      end: 112200000,
      seq_region_name: '2'
    }, {
      seq_region_name: '2',
      id: 'q14.1',
      end: 118100000,
      stain: 'gpos50',
      start: 112200001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 121600000,
      id: 'q14.2',
      seq_region_name: '2',
      stain: 'gneg',
      start: 118100001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 121600001,
      stain: 'gpos50',
      seq_region_name: '2',
      id: 'q14.3',
      end: 129100000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q21.1',
      end: 131700000,
      seq_region_name: '2',
      stain: 'gneg',
      start: 129100001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 131700001,
      stain: 'gpos25',
      end: 134300000,
      id: 'q21.2',
      seq_region_name: '2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 134300001,
      seq_region_name: '2',
      end: 136100000,
      id: 'q21.3'
    }, {
      end: 141500000,
      id: 'q22.1',
      seq_region_name: '2',
      start: 136100001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 143400000,
      id: 'q22.2',
      seq_region_name: '2',
      stain: 'gneg',
      start: 141500001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '2',
      id: 'q22.3',
      end: 147900000,
      stain: 'gpos100',
      start: 143400001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q23.1',
      end: 149000000,
      seq_region_name: '2',
      stain: 'gneg',
      start: 147900001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      id: 'q23.2',
      end: 149600000,
      stain: 'gpos25',
      start: 149000001
    }, {
      start: 149600001,
      stain: 'gneg',
      id: 'q23.3',
      end: 154000000,
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 158900000,
      id: 'q24.1',
      seq_region_name: '2',
      stain: 'gpos75',
      start: 154000001
    }, {
      stain: 'gneg',
      start: 158900001,
      id: 'q24.2',
      end: 162900000,
      seq_region_name: '2',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '2',
      id: 'q24.3',
      end: 168900000,
      stain: 'gpos75',
      start: 162900001
    }, {
      end: 177100000,
      id: 'q31.1',
      seq_region_name: '2',
      start: 168900001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 177100001,
      seq_region_name: '2',
      id: 'q31.2',
      end: 179700000
    }, {
      seq_region_name: '2',
      end: 182100000,
      id: 'q31.3',
      start: 179700001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      id: 'q32.1',
      end: 188500000,
      start: 182100001,
      stain: 'gpos75'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 188500001,
      end: 191100000,
      id: 'q32.2',
      seq_region_name: '2'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 191100001,
      stain: 'gpos75',
      end: 196600000,
      id: 'q32.3',
      seq_region_name: '2'
    }, {
      start: 196600001,
      stain: 'gneg',
      end: 202500000,
      id: 'q33.1',
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 204100000,
      id: 'q33.2',
      seq_region_name: '2',
      stain: 'gpos50',
      start: 202500001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '2',
      end: 208200000,
      id: 'q33.3',
      start: 204100001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q34',
      end: 214500000,
      seq_region_name: '2',
      start: 208200001,
      stain: 'gpos100',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '2',
      end: 220700000,
      id: 'q35',
      stain: 'gneg',
      start: 214500001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos75',
      start: 220700001,
      seq_region_name: '2',
      id: 'q36.1',
      end: 224300000
    }, {
      seq_region_name: '2',
      end: 225200000,
      id: 'q36.2',
      stain: 'gneg',
      start: 224300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 225200001,
      stain: 'gpos100',
      id: 'q36.3',
      end: 230100000,
      seq_region_name: '2',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 230100001,
      stain: 'gneg',
      end: 234700000,
      id: 'q37.1',
      seq_region_name: '2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '2',
      end: 236400000,
      id: 'q37.2',
      start: 234700001,
      stain: 'gpos50'
    }, {
      stain: 'gneg',
      start: 236400001,
      seq_region_name: '2',
      end: 242193529,
      id: 'q37.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }],
    coord_system: 'chromosome'
  }, {
    name: '4',
    coord_system: 'chromosome',
    bands: [{
      id: 'p11',
      end: 50000000,
      seq_region_name: '4',
      stain: 'acen',
      start: 48200001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 44600001,
      seq_region_name: '4',
      id: 'p12',
      end: 48200000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 41200001,
      seq_region_name: '4',
      end: 44600000,
      id: 'p13'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 35800001,
      stain: 'gneg',
      id: 'p14',
      end: 41200000,
      seq_region_name: '4'
    }, {
      start: 27700001,
      stain: 'gpos100',
      id: 'p15.1',
      end: 35800000,
      seq_region_name: '4',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p15.2',
      end: 27700000,
      seq_region_name: '4',
      start: 21300001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 17700001,
      stain: 'gpos75',
      end: 21300000,
      id: 'p15.31',
      seq_region_name: '4'
    }, {
      start: 15000001,
      stain: 'gneg',
      seq_region_name: '4',
      id: 'p15.32',
      end: 17700000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos50',
      start: 11300001,
      end: 15000000,
      id: 'p15.33',
      seq_region_name: '4',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '4',
      id: 'p16.1',
      end: 11300000,
      start: 6000001,
      stain: 'gneg'
    }, {
      end: 6000000,
      id: 'p16.2',
      seq_region_name: '4',
      start: 4500001,
      stain: 'gpos25',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 1,
      stain: 'gneg',
      end: 4500000,
      id: 'p16.3',
      seq_region_name: '4',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '4',
      id: 'q11',
      end: 51800000,
      stain: 'acen',
      start: 50000001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '4',
      end: 58500000,
      id: 'q12',
      stain: 'gneg',
      start: 51800001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 58500001,
      stain: 'gpos100',
      seq_region_name: '4',
      end: 65500000,
      id: 'q13.1'
    }, {
      stain: 'gneg',
      start: 65500001,
      seq_region_name: '4',
      id: 'q13.2',
      end: 69400000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '4',
      id: 'q13.3',
      end: 75300000,
      start: 69400001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 75300001,
      end: 78000000,
      id: 'q21.1',
      seq_region_name: '4'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 81500000,
      id: 'q21.21',
      seq_region_name: '4',
      stain: 'gpos50',
      start: 78000001
    }, {
      seq_region_name: '4',
      end: 83200000,
      id: 'q21.22',
      stain: 'gneg',
      start: 81500001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 86000000,
      id: 'q21.23',
      seq_region_name: '4',
      start: 83200001,
      stain: 'gpos25'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 86000001,
      id: 'q21.3',
      end: 87100000,
      seq_region_name: '4'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '4',
      end: 92800000,
      id: 'q22.1',
      start: 87100001,
      stain: 'gpos75'
    }, {
      end: 94200000,
      id: 'q22.2',
      seq_region_name: '4',
      start: 92800001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '4',
      end: 97900000,
      id: 'q22.3',
      stain: 'gpos75',
      start: 94200001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q23',
      end: 100100000,
      seq_region_name: '4',
      start: 97900001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '4',
      id: 'q24',
      end: 106700000,
      start: 100100001,
      stain: 'gpos50'
    }, {
      start: 106700001,
      stain: 'gneg',
      id: 'q25',
      end: 113200000,
      seq_region_name: '4',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q26',
      end: 119900000,
      seq_region_name: '4',
      start: 113200001,
      stain: 'gpos75'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '4',
      id: 'q27',
      end: 122800000,
      start: 119900001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '4',
      end: 127900000,
      id: 'q28.1',
      start: 122800001,
      stain: 'gpos50'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 127900001,
      seq_region_name: '4',
      id: 'q28.2',
      end: 130100000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 130100001,
      stain: 'gpos100',
      id: 'q28.3',
      end: 138500000,
      seq_region_name: '4'
    }, {
      stain: 'gneg',
      start: 138500001,
      seq_region_name: '4',
      id: 'q31.1',
      end: 140600000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 145900000,
      id: 'q31.21',
      seq_region_name: '4',
      start: 140600001,
      stain: 'gpos25',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '4',
      end: 147500000,
      id: 'q31.22',
      start: 145900001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos25',
      start: 147500001,
      id: 'q31.23',
      end: 150200000,
      seq_region_name: '4',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 150200001,
      end: 154600000,
      id: 'q31.3',
      seq_region_name: '4',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 154600001,
      stain: 'gpos100',
      seq_region_name: '4',
      id: 'q32.1',
      end: 160800000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 160800001,
      stain: 'gneg',
      end: 163600000,
      id: 'q32.2',
      seq_region_name: '4'
    }, {
      end: 169200000,
      id: 'q32.3',
      seq_region_name: '4',
      start: 163600001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 169200001,
      stain: 'gneg',
      seq_region_name: '4',
      end: 171000000,
      id: 'q33'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '4',
      id: 'q34.1',
      end: 175400000,
      start: 171000001,
      stain: 'gpos75'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 175400001,
      stain: 'gneg',
      end: 176600000,
      id: 'q34.2',
      seq_region_name: '4'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '4',
      id: 'q34.3',
      end: 182300000,
      stain: 'gpos100',
      start: 176600001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 182300001,
      stain: 'gneg',
      id: 'q35.1',
      end: 186200000,
      seq_region_name: '4'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 190214555,
      id: 'q35.2',
      seq_region_name: '4',
      start: 186200001,
      stain: 'gpos25'
    }],
    length: 190214555
  }, {
    length: 46709983,
    bands: [{
      stain: 'acen',
      start: 10900001,
      seq_region_name: '21',
      id: 'p11.1',
      end: 12000000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 10900000,
      id: 'p11.2',
      seq_region_name: '21',
      start: 7000001,
      stain: 'gvar',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 3100001,
      stain: 'stalk',
      seq_region_name: '21',
      end: 7000000,
      id: 'p12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p13',
      end: 3100000,
      seq_region_name: '21',
      stain: 'gvar',
      start: 1,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'acen',
      start: 12000001,
      end: 13000000,
      id: 'q11.1',
      seq_region_name: '21'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 13000001,
      stain: 'gneg',
      seq_region_name: '21',
      end: 15000000,
      id: 'q11.2'
    }, {
      stain: 'gpos100',
      start: 15000001,
      end: 22600000,
      id: 'q21.1',
      seq_region_name: '21',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 22600001,
      stain: 'gneg',
      seq_region_name: '21',
      id: 'q21.2',
      end: 25500000
    }, {
      end: 30200000,
      id: 'q21.3',
      seq_region_name: '21',
      start: 25500001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 30200001,
      seq_region_name: '21',
      id: 'q22.11',
      end: 34400000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 36400000,
      id: 'q22.12',
      seq_region_name: '21',
      start: 34400001,
      stain: 'gpos50'
    }, {
      seq_region_name: '21',
      id: 'q22.13',
      end: 38300000,
      stain: 'gneg',
      start: 36400001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 38300001,
      id: 'q22.2',
      end: 41200000,
      seq_region_name: '21'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 46709983,
      id: 'q22.3',
      seq_region_name: '21',
      start: 41200001,
      stain: 'gneg'
    }],
    coord_system: 'chromosome',
    name: '21'
  }, {
    bands: [{
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'acen',
      start: 42200001,
      id: 'p11.1',
      end: 43000000,
      seq_region_name: '9'
    }, {
      stain: 'gneg',
      start: 40000001,
      end: 42200000,
      id: 'p11.2',
      seq_region_name: '9',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '9',
      end: 40000000,
      id: 'p12',
      stain: 'gpos50',
      start: 39000001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 37900001,
      end: 39000000,
      id: 'p13.1',
      seq_region_name: '9'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 36300001,
      stain: 'gpos25',
      seq_region_name: '9',
      end: 37900000,
      id: 'p13.2'
    }, {
      start: 33200001,
      stain: 'gneg',
      seq_region_name: '9',
      end: 36300000,
      id: 'p13.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos100',
      start: 28000001,
      seq_region_name: '9',
      id: 'p21.1',
      end: 33200000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 25600001,
      seq_region_name: '9',
      end: 28000000,
      id: 'p21.2'
    }, {
      stain: 'gpos100',
      start: 19900001,
      seq_region_name: '9',
      id: 'p21.3',
      end: 25600000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '9',
      end: 19900000,
      id: 'p22.1',
      start: 18500001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 16600001,
      stain: 'gpos25',
      end: 18500000,
      id: 'p22.2',
      seq_region_name: '9'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 16600000,
      id: 'p22.3',
      seq_region_name: '9',
      stain: 'gneg',
      start: 14200001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '9',
      end: 14200000,
      id: 'p23',
      stain: 'gpos75',
      start: 9000001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 4600001,
      seq_region_name: '9',
      end: 9000000,
      id: 'p24.1'
    }, {
      start: 2200001,
      stain: 'gpos25',
      end: 4600000,
      id: 'p24.2',
      seq_region_name: '9',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '9',
      end: 2200000,
      id: 'p24.3',
      start: 1,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q11',
      end: 45500000,
      seq_region_name: '9',
      stain: 'acen',
      start: 43000001
    }, {
      stain: 'gvar',
      start: 45500001,
      seq_region_name: '9',
      id: 'q12',
      end: 61500000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 61500001,
      stain: 'gneg',
      seq_region_name: '9',
      id: 'q13',
      end: 65000000
    }, {
      end: 69300000,
      id: 'q21.11',
      seq_region_name: '9',
      stain: 'gpos25',
      start: 65000001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 69300001,
      stain: 'gneg',
      end: 71300000,
      id: 'q21.12',
      seq_region_name: '9',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '9',
      id: 'q21.13',
      end: 76600000,
      start: 71300001,
      stain: 'gpos50'
    }, {
      end: 78500000,
      id: 'q21.2',
      seq_region_name: '9',
      stain: 'gneg',
      start: 76600001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 81500000,
      id: 'q21.31',
      seq_region_name: '9',
      start: 78500001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 84300000,
      id: 'q21.32',
      seq_region_name: '9',
      stain: 'gneg',
      start: 81500001
    }, {
      start: 84300001,
      stain: 'gpos50',
      end: 87800000,
      id: 'q21.33',
      seq_region_name: '9',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q22.1',
      end: 89200000,
      seq_region_name: '9',
      start: 87800001,
      stain: 'gneg'
    }, {
      seq_region_name: '9',
      id: 'q22.2',
      end: 91200000,
      start: 89200001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 91200001,
      stain: 'gneg',
      seq_region_name: '9',
      end: 93900000,
      id: 'q22.31',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 93900001,
      stain: 'gpos25',
      seq_region_name: '9',
      end: 96500000,
      id: 'q22.32'
    }, {
      start: 96500001,
      stain: 'gneg',
      end: 99800000,
      id: 'q22.33',
      seq_region_name: '9',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos100',
      start: 99800001,
      id: 'q31.1',
      end: 105400000,
      seq_region_name: '9'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 105400001,
      stain: 'gneg',
      id: 'q31.2',
      end: 108500000,
      seq_region_name: '9'
    }, {
      seq_region_name: '9',
      end: 112100000,
      id: 'q31.3',
      start: 108500001,
      stain: 'gpos25',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 112100001,
      stain: 'gneg',
      end: 114900000,
      id: 'q32',
      seq_region_name: '9',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '9',
      end: 119800000,
      id: 'q33.1',
      start: 114900001,
      stain: 'gpos75'
    }, {
      id: 'q33.2',
      end: 123100000,
      seq_region_name: '9',
      start: 119800001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q33.3',
      end: 127500000,
      seq_region_name: '9',
      stain: 'gpos25',
      start: 123100001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 127500001,
      stain: 'gneg',
      seq_region_name: '9',
      end: 130600000,
      id: 'q34.11'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 130600001,
      end: 131100000,
      id: 'q34.12',
      seq_region_name: '9'
    }, {
      id: 'q34.13',
      end: 133100000,
      seq_region_name: '9',
      start: 131100001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 133100001,
      stain: 'gpos25',
      end: 134500000,
      id: 'q34.2',
      seq_region_name: '9'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 134500001,
      stain: 'gneg',
      seq_region_name: '9',
      id: 'q34.3',
      end: 138394717
    }],
    coord_system: 'chromosome',
    length: 138394717,
    name: '9'
  }, {
    name: '11',
    length: 135086622,
    coord_system: 'chromosome',
    bands: [{
      id: 'p11.11',
      end: 53400000,
      seq_region_name: '11',
      start: 51000001,
      stain: 'acen',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 48800001,
      end: 51000000,
      id: 'p11.12',
      seq_region_name: '11'
    }, {
      seq_region_name: '11',
      end: 48800000,
      id: 'p11.2',
      start: 43400001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'p12',
      end: 43400000,
      seq_region_name: '11',
      stain: 'gpos100',
      start: 36400001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p13',
      end: 36400000,
      seq_region_name: '11',
      stain: 'gneg',
      start: 31000001
    }, {
      id: 'p14.1',
      end: 31000000,
      seq_region_name: '11',
      stain: 'gpos75',
      start: 27200001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 27200000,
      id: 'p14.2',
      seq_region_name: '11',
      start: 26200001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos100',
      start: 22000001,
      seq_region_name: '11',
      end: 26200000,
      id: 'p14.3'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 16900001,
      seq_region_name: '11',
      end: 22000000,
      id: 'p15.1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '11',
      id: 'p15.2',
      end: 16900000,
      start: 13800001,
      stain: 'gpos50'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 13800000,
      id: 'p15.3',
      seq_region_name: '11',
      start: 11700001,
      stain: 'gneg'
    }, {
      start: 2800001,
      stain: 'gpos50',
      seq_region_name: '11',
      id: 'p15.4',
      end: 11700000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '11',
      end: 2800000,
      id: 'p15.5',
      stain: 'gneg',
      start: 1
    }, {
      stain: 'acen',
      start: 53400001,
      seq_region_name: '11',
      end: 55800000,
      id: 'q11',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '11',
      id: 'q12.1',
      end: 60100000,
      start: 55800001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 60100001,
      seq_region_name: '11',
      end: 61900000,
      id: 'q12.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 61900001,
      stain: 'gpos25',
      seq_region_name: '11',
      id: 'q12.3',
      end: 63600000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 63600001,
      stain: 'gneg',
      id: 'q13.1',
      end: 66100000,
      seq_region_name: '11'
    }, {
      seq_region_name: '11',
      id: 'q13.2',
      end: 68700000,
      start: 66100001,
      stain: 'gpos25',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 70500000,
      id: 'q13.3',
      seq_region_name: '11',
      stain: 'gneg',
      start: 68700001
    }, {
      start: 70500001,
      stain: 'gpos50',
      seq_region_name: '11',
      end: 75500000,
      id: 'q13.4',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '11',
      id: 'q13.5',
      end: 77400000,
      start: 75500001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '11',
      id: 'q14.1',
      end: 85900000,
      start: 77400001,
      stain: 'gpos100'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 88600000,
      id: 'q14.2',
      seq_region_name: '11',
      stain: 'gneg',
      start: 85900001
    }, {
      id: 'q14.3',
      end: 93000000,
      seq_region_name: '11',
      stain: 'gpos100',
      start: 88600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 97400000,
      id: 'q21',
      seq_region_name: '11',
      start: 93000001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 102300000,
      id: 'q22.1',
      seq_region_name: '11',
      stain: 'gpos100',
      start: 97400001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 103000000,
      id: 'q22.2',
      seq_region_name: '11',
      stain: 'gneg',
      start: 102300001
    }, {
      stain: 'gpos100',
      start: 103000001,
      seq_region_name: '11',
      id: 'q22.3',
      end: 110600000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 110600001,
      stain: 'gneg',
      seq_region_name: '11',
      end: 112700000,
      id: 'q23.1'
    }, {
      end: 114600000,
      id: 'q23.2',
      seq_region_name: '11',
      stain: 'gpos50',
      start: 112700001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '11',
      id: 'q23.3',
      end: 121300000,
      stain: 'gneg',
      start: 114600001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 121300001,
      stain: 'gpos50',
      id: 'q24.1',
      end: 124000000,
      seq_region_name: '11'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q24.2',
      end: 127900000,
      seq_region_name: '11',
      stain: 'gneg',
      start: 124000001
    }, {
      stain: 'gpos50',
      start: 127900001,
      seq_region_name: '11',
      end: 130900000,
      id: 'q24.3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '11',
      end: 135086622,
      id: 'q25',
      stain: 'gneg',
      start: 130900001,
      strand: 0,
      assembly_name: 'GRCh38'
    }]
  }, {
    name: '17',
    length: 83257441,
    coord_system: 'chromosome',
    bands: [{
      stain: 'acen',
      start: 22700001,
      seq_region_name: '17',
      end: 25100000,
      id: 'p11.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p11.2',
      end: 22700000,
      seq_region_name: '17',
      start: 16100001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 10800001,
      stain: 'gpos75',
      seq_region_name: '17',
      end: 16100000,
      id: 'p12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p13.1',
      end: 10800000,
      seq_region_name: '17',
      stain: 'gneg',
      start: 6500001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 3400001,
      seq_region_name: '17',
      end: 6500000,
      id: 'p13.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 1,
      stain: 'gneg',
      seq_region_name: '17',
      end: 3400000,
      id: 'p13.3'
    }, {
      start: 25100001,
      stain: 'acen',
      seq_region_name: '17',
      end: 27400000,
      id: 'q11.1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 27400001,
      seq_region_name: '17',
      id: 'q11.2',
      end: 33500000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 33500001,
      stain: 'gpos50',
      id: 'q12',
      end: 39800000,
      seq_region_name: '17',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q21.1',
      end: 40200000,
      seq_region_name: '17',
      start: 39800001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '17',
      id: 'q21.2',
      end: 42800000,
      stain: 'gpos25',
      start: 40200001
    }, {
      seq_region_name: '17',
      end: 46800000,
      id: 'q21.31',
      start: 42800001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 49300000,
      id: 'q21.32',
      seq_region_name: '17',
      start: 46800001,
      stain: 'gpos25'
    }, {
      stain: 'gneg',
      start: 49300001,
      id: 'q21.33',
      end: 52100000,
      seq_region_name: '17',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 59500000,
      id: 'q22',
      seq_region_name: '17',
      stain: 'gpos75',
      start: 52100001
    }, {
      seq_region_name: '17',
      end: 60200000,
      id: 'q23.1',
      start: 59500001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 60200001,
      stain: 'gpos75',
      end: 63100000,
      id: 'q23.2',
      seq_region_name: '17',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 64600000,
      id: 'q23.3',
      seq_region_name: '17',
      stain: 'gneg',
      start: 63100001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 64600001,
      stain: 'gpos50',
      end: 66200000,
      id: 'q24.1',
      seq_region_name: '17'
    }, {
      end: 69100000,
      id: 'q24.2',
      seq_region_name: '17',
      stain: 'gneg',
      start: 66200001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 72900000,
      id: 'q24.3',
      seq_region_name: '17',
      start: 69100001,
      stain: 'gpos75'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 72900001,
      stain: 'gneg',
      seq_region_name: '17',
      id: 'q25.1',
      end: 76800000
    }, {
      seq_region_name: '17',
      end: 77200000,
      id: 'q25.2',
      stain: 'gpos25',
      start: 76800001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 77200001,
      stain: 'gneg',
      id: 'q25.3',
      end: 83257441,
      seq_region_name: '17'
    }]
  }, {
    name: '8',
    coord_system: 'chromosome',
    bands: [{
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '8',
      id: 'p11.1',
      end: 45200000,
      start: 43200001,
      stain: 'acen'
    }, {
      start: 39900001,
      stain: 'gneg',
      seq_region_name: '8',
      end: 43200000,
      id: 'p11.21',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 38500001,
      seq_region_name: '8',
      end: 39900000,
      id: 'p11.22'
    }, {
      seq_region_name: '8',
      id: 'p11.23',
      end: 38500000,
      stain: 'gneg',
      start: 36700001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '8',
      id: 'p12',
      end: 36700000,
      stain: 'gpos75',
      start: 29000001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '8',
      end: 29000000,
      id: 'p21.1',
      stain: 'gneg',
      start: 27500001
    }, {
      start: 23500001,
      stain: 'gpos50',
      end: 27500000,
      id: 'p21.2',
      seq_region_name: '8',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 19200001,
      stain: 'gneg',
      seq_region_name: '8',
      id: 'p21.3',
      end: 23500000
    }, {
      stain: 'gpos100',
      start: 12800001,
      end: 19200000,
      id: 'p22',
      seq_region_name: '8',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '8',
      end: 12800000,
      id: 'p23.1',
      stain: 'gneg',
      start: 6300001
    }, {
      id: 'p23.2',
      end: 6300000,
      seq_region_name: '8',
      start: 2300001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 1,
      stain: 'gneg',
      end: 2300000,
      id: 'p23.3',
      seq_region_name: '8',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'acen',
      start: 45200001,
      end: 47200000,
      id: 'q11.1',
      seq_region_name: '8'
    }, {
      start: 47200001,
      stain: 'gneg',
      id: 'q11.21',
      end: 51300000,
      seq_region_name: '8',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 51300001,
      stain: 'gpos75',
      id: 'q11.22',
      end: 51700000,
      seq_region_name: '8',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 51700001,
      id: 'q11.23',
      end: 54600000,
      seq_region_name: '8'
    }, {
      start: 54600001,
      stain: 'gpos50',
      id: 'q12.1',
      end: 60600000,
      seq_region_name: '8',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 60600001,
      stain: 'gneg',
      id: 'q12.2',
      end: 61300000,
      seq_region_name: '8'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '8',
      id: 'q12.3',
      end: 65100000,
      stain: 'gpos50',
      start: 61300001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 65100001,
      stain: 'gneg',
      seq_region_name: '8',
      end: 67100000,
      id: 'q13.1'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 69600000,
      id: 'q13.2',
      seq_region_name: '8',
      start: 67100001,
      stain: 'gpos50'
    }, {
      stain: 'gneg',
      start: 69600001,
      seq_region_name: '8',
      end: 72000000,
      id: 'q13.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q21.11',
      end: 74600000,
      seq_region_name: '8',
      start: 72000001,
      stain: 'gpos100'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q21.12',
      end: 74700000,
      seq_region_name: '8',
      start: 74600001,
      stain: 'gneg'
    }, {
      stain: 'gpos75',
      start: 74700001,
      end: 83500000,
      id: 'q21.13',
      seq_region_name: '8',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 85900000,
      id: 'q21.2',
      seq_region_name: '8',
      stain: 'gneg',
      start: 83500001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 92300000,
      id: 'q21.3',
      seq_region_name: '8',
      stain: 'gpos100',
      start: 85900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '8',
      end: 97900000,
      id: 'q22.1',
      stain: 'gneg',
      start: 92300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '8',
      id: 'q22.2',
      end: 100500000,
      start: 97900001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 100500001,
      id: 'q22.3',
      end: 105100000,
      seq_region_name: '8'
    }, {
      stain: 'gpos75',
      start: 105100001,
      end: 109500000,
      id: 'q23.1',
      seq_region_name: '8',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 109500001,
      end: 111100000,
      id: 'q23.2',
      seq_region_name: '8',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '8',
      id: 'q23.3',
      end: 116700000,
      start: 111100001,
      stain: 'gpos100'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 116700001,
      stain: 'gneg',
      id: 'q24.11',
      end: 118300000,
      seq_region_name: '8'
    }, {
      stain: 'gpos50',
      start: 118300001,
      seq_region_name: '8',
      end: 121500000,
      id: 'q24.12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '8',
      id: 'q24.13',
      end: 126300000,
      stain: 'gneg',
      start: 121500001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 126300001,
      seq_region_name: '8',
      id: 'q24.21',
      end: 130400000
    }, {
      seq_region_name: '8',
      end: 135400000,
      id: 'q24.22',
      start: 130400001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '8',
      id: 'q24.23',
      end: 138900000,
      stain: 'gpos75',
      start: 135400001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '8',
      id: 'q24.3',
      end: 145138636,
      start: 138900001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }],
    length: 145138636
  }, {
    name: '7',
    length: 159345973,
    bands: [{
      stain: 'acen',
      start: 58100001,
      id: 'p11.1',
      end: 60100000,
      seq_region_name: '7',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '7',
      id: 'p11.2',
      end: 58100000,
      start: 53900001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '7',
      end: 53900000,
      id: 'p12.1',
      stain: 'gpos75',
      start: 50500001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 49000001,
      stain: 'gneg',
      seq_region_name: '7',
      id: 'p12.2',
      end: 50500000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 49000000,
      id: 'p12.3',
      seq_region_name: '7',
      stain: 'gpos75',
      start: 45400001
    }, {
      stain: 'gneg',
      start: 43300001,
      seq_region_name: '7',
      end: 45400000,
      id: 'p13',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos75',
      start: 37100001,
      end: 43300000,
      id: 'p14.1',
      seq_region_name: '7',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '7',
      end: 37100000,
      id: 'p14.2',
      stain: 'gneg',
      start: 34900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '7',
      end: 34900000,
      id: 'p14.3',
      stain: 'gpos75',
      start: 28800001
    }, {
      seq_region_name: '7',
      id: 'p15.1',
      end: 28800000,
      stain: 'gneg',
      start: 27900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos50',
      start: 25500001,
      id: 'p15.2',
      end: 27900000,
      seq_region_name: '7',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p15.3',
      end: 25500000,
      seq_region_name: '7',
      stain: 'gneg',
      start: 20900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 16500001,
      stain: 'gpos100',
      seq_region_name: '7',
      end: 20900000,
      id: 'p21.1'
    }, {
      start: 13700001,
      stain: 'gneg',
      id: 'p21.2',
      end: 16500000,
      seq_region_name: '7',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 13700000,
      id: 'p21.3',
      seq_region_name: '7',
      start: 7200001,
      stain: 'gpos100'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 4500001,
      seq_region_name: '7',
      end: 7200000,
      id: 'p22.1'
    }, {
      stain: 'gpos25',
      start: 2800001,
      id: 'p22.2',
      end: 4500000,
      seq_region_name: '7',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 1,
      stain: 'gneg',
      seq_region_name: '7',
      end: 2800000,
      id: 'p22.3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'acen',
      start: 60100001,
      seq_region_name: '7',
      id: 'q11.1',
      end: 62100000
    }, {
      seq_region_name: '7',
      end: 67500000,
      id: 'q11.21',
      start: 62100001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 67500001,
      stain: 'gpos50',
      seq_region_name: '7',
      id: 'q11.22',
      end: 72700000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 72700001,
      id: 'q11.23',
      end: 77900000,
      seq_region_name: '7',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 86700000,
      id: 'q21.11',
      seq_region_name: '7',
      start: 77900001,
      stain: 'gpos100',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '7',
      id: 'q21.12',
      end: 88500000,
      start: 86700001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '7',
      end: 91500000,
      id: 'q21.13',
      start: 88500001,
      stain: 'gpos75'
    }, {
      stain: 'gneg',
      start: 91500001,
      id: 'q21.2',
      end: 93300000,
      seq_region_name: '7',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos75',
      start: 93300001,
      end: 98400000,
      id: 'q21.3',
      seq_region_name: '7',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 98400001,
      stain: 'gneg',
      seq_region_name: '7',
      end: 104200000,
      id: 'q22.1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '7',
      end: 104900000,
      id: 'q22.2',
      stain: 'gpos50',
      start: 104200001
    }, {
      seq_region_name: '7',
      end: 107800000,
      id: 'q22.3',
      stain: 'gneg',
      start: 104900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 107800001,
      end: 115000000,
      id: 'q31.1',
      seq_region_name: '7'
    }, {
      start: 115000001,
      stain: 'gneg',
      seq_region_name: '7',
      end: 117700000,
      id: 'q31.2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos75',
      start: 117700001,
      seq_region_name: '7',
      end: 121400000,
      id: 'q31.31',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 124100000,
      id: 'q31.32',
      seq_region_name: '7',
      stain: 'gneg',
      start: 121400001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 124100001,
      stain: 'gpos75',
      id: 'q31.33',
      end: 127500000,
      seq_region_name: '7'
    }, {
      start: 127500001,
      stain: 'gneg',
      id: 'q32.1',
      end: 129600000,
      seq_region_name: '7',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '7',
      id: 'q32.2',
      end: 130800000,
      stain: 'gpos25',
      start: 129600001
    }, {
      seq_region_name: '7',
      end: 132900000,
      id: 'q32.3',
      start: 130800001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos50',
      start: 132900001,
      seq_region_name: '7',
      end: 138500000,
      id: 'q33',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 138500001,
      id: 'q34',
      end: 143400000,
      seq_region_name: '7'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 148200000,
      id: 'q35',
      seq_region_name: '7',
      start: 143400001,
      stain: 'gpos75'
    }, {
      seq_region_name: '7',
      id: 'q36.1',
      end: 152800000,
      start: 148200001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '7',
      id: 'q36.2',
      end: 155200000,
      start: 152800001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '7',
      end: 159345973,
      id: 'q36.3',
      start: 155200001,
      stain: 'gneg'
    }],
    coord_system: 'chromosome'
  }, {
    name: '15',
    length: 101991189,
    bands: [{
      id: 'p11.1',
      end: 19000000,
      seq_region_name: '15',
      start: 17500001,
      stain: 'acen',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 9700001,
      stain: 'gvar',
      seq_region_name: '15',
      end: 17500000,
      id: 'p11.2'
    }, {
      start: 4200001,
      stain: 'stalk',
      end: 9700000,
      id: 'p12',
      seq_region_name: '15',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 1,
      stain: 'gvar',
      id: 'p13',
      end: 4200000,
      seq_region_name: '15',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 20500000,
      id: 'q11.1',
      seq_region_name: '15',
      start: 19000001,
      stain: 'acen'
    }, {
      start: 20500001,
      stain: 'gneg',
      seq_region_name: '15',
      end: 25500000,
      id: 'q11.2',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 25500001,
      stain: 'gpos50',
      end: 27800000,
      id: 'q12',
      seq_region_name: '15',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 27800001,
      stain: 'gneg',
      seq_region_name: '15',
      end: 30000000,
      id: 'q13.1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos50',
      start: 30000001,
      seq_region_name: '15',
      end: 30900000,
      id: 'q13.2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '15',
      id: 'q13.3',
      end: 33400000,
      start: 30900001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '15',
      end: 39800000,
      id: 'q14',
      stain: 'gpos75',
      start: 33400001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 39800001,
      end: 42500000,
      id: 'q15.1',
      seq_region_name: '15'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos25',
      start: 42500001,
      end: 43300000,
      id: 'q15.2',
      seq_region_name: '15'
    }, {
      seq_region_name: '15',
      id: 'q15.3',
      end: 44500000,
      stain: 'gneg',
      start: 43300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 44500001,
      stain: 'gpos75',
      end: 49200000,
      id: 'q21.1',
      seq_region_name: '15',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '15',
      end: 52600000,
      id: 'q21.2',
      stain: 'gneg',
      start: 49200001
    }, {
      seq_region_name: '15',
      end: 58800000,
      id: 'q21.3',
      start: 52600001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '15',
      end: 59000000,
      id: 'q22.1',
      start: 58800001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 59000001,
      stain: 'gpos25',
      seq_region_name: '15',
      end: 63400000,
      id: 'q22.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 63400001,
      id: 'q22.31',
      end: 66900000,
      seq_region_name: '15'
    }, {
      seq_region_name: '15',
      end: 67000000,
      id: 'q22.32',
      start: 66900001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 67000001,
      seq_region_name: '15',
      id: 'q22.33',
      end: 67200000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos25',
      start: 67200001,
      id: 'q23',
      end: 72400000,
      seq_region_name: '15',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 72400001,
      stain: 'gneg',
      id: 'q24.1',
      end: 74900000,
      seq_region_name: '15',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q24.2',
      end: 76300000,
      seq_region_name: '15',
      start: 74900001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '15',
      id: 'q24.3',
      end: 78000000,
      stain: 'gneg',
      start: 76300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos50',
      start: 78000001,
      seq_region_name: '15',
      id: 'q25.1',
      end: 81400000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 81400001,
      id: 'q25.2',
      end: 84700000,
      seq_region_name: '15',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '15',
      id: 'q25.3',
      end: 88500000,
      start: 84700001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q26.1',
      end: 93800000,
      seq_region_name: '15',
      start: 88500001,
      stain: 'gneg'
    }, {
      end: 98000000,
      id: 'q26.2',
      seq_region_name: '15',
      start: 93800001,
      stain: 'gpos50',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 98000001,
      id: 'q26.3',
      end: 101991189,
      seq_region_name: '15',
      assembly_name: 'GRCh38',
      strand: 0
    }],
    coord_system: 'chromosome'
  }, {
    coord_system: 'chromosome',
    bands: [{
      strand: 0,
      assembly_name: 'GRCh38',
      start: 33200001,
      stain: 'acen',
      seq_region_name: '12',
      end: 35500000,
      id: 'p11.1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 30500001,
      stain: 'gneg',
      seq_region_name: '12',
      id: 'p11.21',
      end: 33200000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '12',
      end: 30500000,
      id: 'p11.22',
      stain: 'gpos50',
      start: 27600001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '12',
      end: 27600000,
      id: 'p11.23',
      stain: 'gneg',
      start: 26300001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 26300000,
      id: 'p12.1',
      seq_region_name: '12',
      start: 21100001,
      stain: 'gpos100'
    }, {
      seq_region_name: '12',
      id: 'p12.2',
      end: 21100000,
      stain: 'gneg',
      start: 19800001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '12',
      end: 19800000,
      id: 'p12.3',
      stain: 'gpos100',
      start: 14600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 14600000,
      id: 'p13.1',
      seq_region_name: '12',
      stain: 'gneg',
      start: 12600001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 12600000,
      id: 'p13.2',
      seq_region_name: '12',
      stain: 'gpos75',
      start: 10000001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'p13.31',
      end: 10000000,
      seq_region_name: '12',
      stain: 'gneg',
      start: 5300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 3200001,
      stain: 'gpos25',
      end: 5300000,
      id: 'p13.32',
      seq_region_name: '12',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 1,
      seq_region_name: '12',
      id: 'p13.33',
      end: 3200000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '12',
      end: 37800000,
      id: 'q11',
      start: 35500001,
      stain: 'acen',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q12',
      end: 46000000,
      seq_region_name: '12',
      stain: 'gpos100',
      start: 37800001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q13.11',
      end: 48700000,
      seq_region_name: '12',
      stain: 'gneg',
      start: 46000001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 48700001,
      seq_region_name: '12',
      end: 51100000,
      id: 'q13.12'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 51100001,
      seq_region_name: '12',
      end: 54500000,
      id: 'q13.13'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q13.2',
      end: 56200000,
      seq_region_name: '12',
      stain: 'gpos25',
      start: 54500001
    }, {
      start: 56200001,
      stain: 'gneg',
      end: 57700000,
      id: 'q13.3',
      seq_region_name: '12',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '12',
      end: 62700000,
      id: 'q14.1',
      start: 57700001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 62700001,
      stain: 'gneg',
      end: 64700000,
      id: 'q14.2',
      seq_region_name: '12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q14.3',
      end: 67300000,
      seq_region_name: '12',
      start: 64700001,
      stain: 'gpos50'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q15',
      end: 71100000,
      seq_region_name: '12',
      stain: 'gneg',
      start: 67300001
    }, {
      seq_region_name: '12',
      id: 'q21.1',
      end: 75300000,
      start: 71100001,
      stain: 'gpos75',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 75300001,
      end: 79900000,
      id: 'q21.2',
      seq_region_name: '12',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 79900001,
      stain: 'gpos100',
      end: 86300000,
      id: 'q21.31',
      seq_region_name: '12',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '12',
      id: 'q21.32',
      end: 88600000,
      start: 86300001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '12',
      end: 92200000,
      id: 'q21.33',
      start: 88600001,
      stain: 'gpos100'
    }, {
      stain: 'gneg',
      start: 92200001,
      seq_region_name: '12',
      end: 95800000,
      id: 'q22',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 101200000,
      id: 'q23.1',
      seq_region_name: '12',
      stain: 'gpos75',
      start: 95800001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 101200001,
      end: 103500000,
      id: 'q23.2',
      seq_region_name: '12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 103500001,
      seq_region_name: '12',
      end: 108600000,
      id: 'q23.3'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '12',
      id: 'q24.11',
      end: 111300000,
      stain: 'gneg',
      start: 108600001
    }, {
      end: 111900000,
      id: 'q24.12',
      seq_region_name: '12',
      start: 111300001,
      stain: 'gpos25',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 111900001,
      id: 'q24.13',
      end: 113900000,
      seq_region_name: '12',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos50',
      start: 113900001,
      seq_region_name: '12',
      end: 116400000,
      id: 'q24.21',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 116400001,
      stain: 'gneg',
      end: 117700000,
      id: 'q24.22',
      seq_region_name: '12',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 120300000,
      id: 'q24.23',
      seq_region_name: '12',
      start: 117700001,
      stain: 'gpos50'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 120300001,
      end: 125400000,
      id: 'q24.31',
      seq_region_name: '12'
    }, {
      end: 128700000,
      id: 'q24.32',
      seq_region_name: '12',
      stain: 'gpos50',
      start: 125400001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 128700001,
      seq_region_name: '12',
      id: 'q24.33',
      end: 133275309
    }],
    length: 133275309,
    name: '12'
  }, {
    name: '1',
    bands: [{
      strand: 0,
      assembly_name: 'GRCh38',
      start: 121700001,
      stain: 'acen',
      id: 'p11.1',
      end: 123400000,
      seq_region_name: '1'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '1',
      id: 'p11.2',
      end: 121700000,
      stain: 'gneg',
      start: 120400001
    }, {
      stain: 'gpos50',
      start: 117200001,
      end: 120400000,
      id: 'p12',
      seq_region_name: '1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '1',
      id: 'p13.1',
      end: 117200000,
      start: 115500001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 111200001,
      seq_region_name: '1',
      id: 'p13.2',
      end: 115500000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p13.3',
      end: 111200000,
      seq_region_name: '1',
      start: 106700001,
      stain: 'gneg'
    }, {
      start: 101800001,
      stain: 'gpos100',
      seq_region_name: '1',
      end: 106700000,
      id: 'p21.1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'p21.2',
      end: 101800000,
      seq_region_name: '1',
      stain: 'gneg',
      start: 99300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos75',
      start: 94300001,
      seq_region_name: '1',
      end: 99300000,
      id: 'p21.3'
    }, {
      id: 'p22.1',
      end: 94300000,
      seq_region_name: '1',
      start: 91500001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos75',
      start: 87900001,
      seq_region_name: '1',
      id: 'p22.2',
      end: 91500000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 84400001,
      stain: 'gneg',
      id: 'p22.3',
      end: 87900000,
      seq_region_name: '1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '1',
      end: 84400000,
      id: 'p31.1',
      stain: 'gpos100',
      start: 69300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      end: 69300000,
      id: 'p31.2',
      seq_region_name: '1',
      stain: 'gneg',
      start: 68500001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 68500000,
      id: 'p31.3',
      seq_region_name: '1',
      start: 60800001,
      stain: 'gpos50'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '1',
      end: 60800000,
      id: 'p32.1',
      stain: 'gneg',
      start: 58500001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 55600001,
      seq_region_name: '1',
      id: 'p32.2',
      end: 58500000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 55600000,
      id: 'p32.3',
      seq_region_name: '1',
      start: 50200001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p33',
      end: 50200000,
      seq_region_name: '1',
      start: 46300001,
      stain: 'gpos75'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 43700001,
      seq_region_name: '1',
      id: 'p34.1',
      end: 46300000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 39600001,
      end: 43700000,
      id: 'p34.2',
      seq_region_name: '1'
    }, {
      start: 34300001,
      stain: 'gneg',
      end: 39600000,
      id: 'p34.3',
      seq_region_name: '1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 32300001,
      stain: 'gpos25',
      seq_region_name: '1',
      id: 'p35.1',
      end: 34300000
    }, {
      end: 32300000,
      id: 'p35.2',
      seq_region_name: '1',
      stain: 'gneg',
      start: 29900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '1',
      end: 29900000,
      id: 'p35.3',
      stain: 'gpos25',
      start: 27600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '1',
      id: 'p36.11',
      end: 27600000,
      stain: 'gneg',
      start: 23600001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '1',
      end: 23600000,
      id: 'p36.12',
      start: 20100001,
      stain: 'gpos25'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '1',
      id: 'p36.13',
      end: 20100000,
      stain: 'gneg',
      start: 15900001
    }, {
      id: 'p36.21',
      end: 15900000,
      seq_region_name: '1',
      start: 12500001,
      stain: 'gpos50',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 12500000,
      id: 'p36.22',
      seq_region_name: '1',
      stain: 'gneg',
      start: 9100001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 7100001,
      stain: 'gpos25',
      seq_region_name: '1',
      end: 9100000,
      id: 'p36.23'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '1',
      id: 'p36.31',
      end: 7100000,
      start: 5300001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 2300001,
      seq_region_name: '1',
      end: 5300000,
      id: 'p36.32'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 1,
      stain: 'gneg',
      id: 'p36.33',
      end: 2300000,
      seq_region_name: '1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 125100000,
      id: 'q11',
      seq_region_name: '1',
      start: 123400001,
      stain: 'acen'
    }, {
      stain: 'gvar',
      start: 125100001,
      end: 143200000,
      id: 'q12',
      seq_region_name: '1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 143200001,
      seq_region_name: '1',
      id: 'q21.1',
      end: 147500000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 147500001,
      stain: 'gpos50',
      end: 150600000,
      id: 'q21.2',
      seq_region_name: '1'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '1',
      end: 155100000,
      id: 'q21.3',
      stain: 'gneg',
      start: 150600001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 155100001,
      stain: 'gpos50',
      seq_region_name: '1',
      id: 'q22',
      end: 156600000
    }, {
      start: 156600001,
      stain: 'gneg',
      id: 'q23.1',
      end: 159100000,
      seq_region_name: '1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 159100001,
      stain: 'gpos50',
      end: 160500000,
      id: 'q23.2',
      seq_region_name: '1'
    }, {
      end: 165500000,
      id: 'q23.3',
      seq_region_name: '1',
      start: 160500001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q24.1',
      end: 167200000,
      seq_region_name: '1',
      start: 165500001,
      stain: 'gpos50'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '1',
      id: 'q24.2',
      end: 170900000,
      stain: 'gneg',
      start: 167200001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 170900001,
      stain: 'gpos75',
      seq_region_name: '1',
      end: 173000000,
      id: 'q24.3'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '1',
      end: 176100000,
      id: 'q25.1',
      start: 173000001,
      stain: 'gneg'
    }, {
      start: 176100001,
      stain: 'gpos50',
      end: 180300000,
      id: 'q25.2',
      seq_region_name: '1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q25.3',
      end: 185800000,
      seq_region_name: '1',
      stain: 'gneg',
      start: 180300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 190800000,
      id: 'q31.1',
      seq_region_name: '1',
      start: 185800001,
      stain: 'gpos100'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 190800001,
      id: 'q31.2',
      end: 193800000,
      seq_region_name: '1'
    }, {
      end: 198700000,
      id: 'q31.3',
      seq_region_name: '1',
      start: 193800001,
      stain: 'gpos100',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q32.1',
      end: 207100000,
      seq_region_name: '1',
      start: 198700001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 207100001,
      stain: 'gpos25',
      id: 'q32.2',
      end: 211300000,
      seq_region_name: '1',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 211300001,
      seq_region_name: '1',
      end: 214400000,
      id: 'q32.3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gpos100',
      start: 214400001,
      seq_region_name: '1',
      id: 'q41',
      end: 223900000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '1',
      id: 'q42.11',
      end: 224400000,
      stain: 'gneg',
      start: 223900001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gpos25',
      start: 224400001,
      end: 226800000,
      id: 'q42.12',
      seq_region_name: '1',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 226800001,
      stain: 'gneg',
      seq_region_name: '1',
      end: 230500000,
      id: 'q42.13',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q42.2',
      end: 234600000,
      seq_region_name: '1',
      stain: 'gpos50',
      start: 230500001
    }, {
      end: 236400000,
      id: 'q42.3',
      seq_region_name: '1',
      start: 234600001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q43',
      end: 243500000,
      seq_region_name: '1',
      start: 236400001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q44',
      end: 248956422,
      seq_region_name: '1',
      stain: 'gneg',
      start: 243500001,
      assembly_name: 'GRCh38',
      strand: 0
    }],
    coord_system: 'chromosome',
    length: 248956422
  }, {
    coord_system: 'chromosome',
    bands: [{
      id: 'p11.1',
      end: 36800000,
      seq_region_name: '16',
      stain: 'acen',
      start: 35300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 28500001,
      stain: 'gneg',
      id: 'p11.2',
      end: 35300000,
      seq_region_name: '16'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 24200001,
      id: 'p12.1',
      end: 28500000,
      seq_region_name: '16'
    }, {
      end: 24200000,
      id: 'p12.2',
      seq_region_name: '16',
      start: 21200001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 16700001,
      end: 21200000,
      id: 'p12.3',
      seq_region_name: '16'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 16700000,
      id: 'p13.11',
      seq_region_name: '16',
      stain: 'gneg',
      start: 14700001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '16',
      end: 14700000,
      id: 'p13.12',
      stain: 'gpos50',
      start: 12500001
    }, {
      start: 10400001,
      stain: 'gneg',
      end: 12500000,
      id: 'p13.13',
      seq_region_name: '16',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '16',
      id: 'p13.2',
      end: 10400000,
      start: 7800001,
      stain: 'gpos50'
    }, {
      seq_region_name: '16',
      id: 'p13.3',
      end: 7800000,
      start: 1,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 36800001,
      stain: 'acen',
      seq_region_name: '16',
      id: 'q11.1',
      end: 38400000
    }, {
      stain: 'gvar',
      start: 38400001,
      seq_region_name: '16',
      id: 'q11.2',
      end: 47000000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '16',
      id: 'q12.1',
      end: 52600000,
      start: 47000001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 52600001,
      seq_region_name: '16',
      end: 56000000,
      id: 'q12.2'
    }, {
      start: 56000001,
      stain: 'gneg',
      end: 57300000,
      id: 'q13',
      seq_region_name: '16',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 57300001,
      stain: 'gpos100',
      seq_region_name: '16',
      end: 66600000,
      id: 'q21'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '16',
      end: 70800000,
      id: 'q22.1',
      stain: 'gneg',
      start: 66600001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 70800001,
      seq_region_name: '16',
      id: 'q22.2',
      end: 72800000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '16',
      end: 74100000,
      id: 'q22.3',
      start: 72800001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '16',
      id: 'q23.1',
      end: 79200000,
      start: 74100001,
      stain: 'gpos75'
    }, {
      stain: 'gneg',
      start: 79200001,
      id: 'q23.2',
      end: 81600000,
      seq_region_name: '16',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 81600001,
      stain: 'gpos50',
      seq_region_name: '16',
      end: 84100000,
      id: 'q23.3'
    }, {
      end: 87000000,
      id: 'q24.1',
      seq_region_name: '16',
      stain: 'gneg',
      start: 84100001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'q24.2',
      end: 88700000,
      seq_region_name: '16',
      stain: 'gpos25',
      start: 87000001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '16',
      end: 90338345,
      id: 'q24.3',
      stain: 'gneg',
      start: 88700001,
      assembly_name: 'GRCh38',
      strand: 0
    }],
    length: 90338345,
    name: '16'
  }, {
    name: '5',
    coord_system: 'chromosome',
    bands: [{
      start: 46100001,
      stain: 'acen',
      id: 'p11',
      end: 48800000,
      seq_region_name: '5',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p12',
      end: 46100000,
      seq_region_name: '5',
      stain: 'gpos50',
      start: 42500001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '5',
      end: 42500000,
      id: 'p13.1',
      start: 38400001,
      stain: 'gneg'
    }, {
      seq_region_name: '5',
      end: 38400000,
      id: 'p13.2',
      stain: 'gpos25',
      start: 33800001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p13.3',
      end: 33800000,
      seq_region_name: '5',
      start: 28900001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '5',
      id: 'p14.1',
      end: 28900000,
      start: 24600001,
      stain: 'gpos100',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      stain: 'gneg',
      start: 23300001,
      seq_region_name: '5',
      id: 'p14.2',
      end: 24600000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '5',
      id: 'p14.3',
      end: 23300000,
      stain: 'gpos100',
      start: 18400001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '5',
      id: 'p15.1',
      end: 18400000,
      stain: 'gneg',
      start: 15000001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos50',
      start: 9900001,
      end: 15000000,
      id: 'p15.2',
      seq_region_name: '5'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 6300001,
      seq_region_name: '5',
      id: 'p15.31',
      end: 9900000
    }, {
      stain: 'gpos25',
      start: 4400001,
      seq_region_name: '5',
      end: 6300000,
      id: 'p15.32',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 1,
      seq_region_name: '5',
      end: 4400000,
      id: 'p15.33',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '5',
      end: 51400000,
      id: 'q11.1',
      start: 48800001,
      stain: 'acen',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '5',
      id: 'q11.2',
      end: 59600000,
      start: 51400001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '5',
      end: 63600000,
      id: 'q12.1',
      start: 59600001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 63600001,
      stain: 'gneg',
      id: 'q12.2',
      end: 63900000,
      seq_region_name: '5'
    }, {
      id: 'q12.3',
      end: 67400000,
      seq_region_name: '5',
      start: 63900001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 69100000,
      id: 'q13.1',
      seq_region_name: '5',
      stain: 'gneg',
      start: 67400001
    }, {
      seq_region_name: '5',
      id: 'q13.2',
      end: 74000000,
      start: 69100001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q13.3',
      end: 77600000,
      seq_region_name: '5',
      start: 74000001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '5',
      id: 'q14.1',
      end: 82100000,
      start: 77600001,
      stain: 'gpos50'
    }, {
      seq_region_name: '5',
      id: 'q14.2',
      end: 83500000,
      stain: 'gneg',
      start: 82100001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 83500001,
      stain: 'gpos100',
      seq_region_name: '5',
      end: 93000000,
      id: 'q14.3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 93000001,
      stain: 'gneg',
      seq_region_name: '5',
      id: 'q15',
      end: 98900000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 98900001,
      stain: 'gpos100',
      end: 103400000,
      id: 'q21.1',
      seq_region_name: '5'
    }, {
      start: 103400001,
      stain: 'gneg',
      id: 'q21.2',
      end: 105100000,
      seq_region_name: '5',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '5',
      id: 'q21.3',
      end: 110200000,
      stain: 'gpos100',
      start: 105100001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 112200000,
      id: 'q22.1',
      seq_region_name: '5',
      stain: 'gneg',
      start: 110200001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 112200001,
      stain: 'gpos50',
      seq_region_name: '5',
      end: 113800000,
      id: 'q22.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 113800001,
      stain: 'gneg',
      seq_region_name: '5',
      end: 115900000,
      id: 'q22.3'
    }, {
      start: 115900001,
      stain: 'gpos100',
      end: 122100000,
      id: 'q23.1',
      seq_region_name: '5',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '5',
      end: 127900000,
      id: 'q23.2',
      stain: 'gneg',
      start: 122100001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 127900001,
      stain: 'gpos100',
      seq_region_name: '5',
      end: 131200000,
      id: 'q23.3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 131200001,
      end: 136900000,
      id: 'q31.1',
      seq_region_name: '5'
    }, {
      seq_region_name: '5',
      id: 'q31.2',
      end: 140100000,
      stain: 'gpos25',
      start: 136900001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '5',
      id: 'q31.3',
      end: 145100000,
      start: 140100001,
      stain: 'gneg'
    }, {
      seq_region_name: '5',
      id: 'q32',
      end: 150400000,
      start: 145100001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '5',
      id: 'q33.1',
      end: 153300000,
      start: 150400001,
      stain: 'gneg'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos50',
      start: 153300001,
      seq_region_name: '5',
      id: 'q33.2',
      end: 156300000
    }, {
      end: 160500000,
      id: 'q33.3',
      seq_region_name: '5',
      stain: 'gneg',
      start: 156300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 160500001,
      stain: 'gpos100',
      seq_region_name: '5',
      id: 'q34',
      end: 169000000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q35.1',
      end: 173300000,
      seq_region_name: '5',
      start: 169000001,
      stain: 'gneg'
    }, {
      seq_region_name: '5',
      id: 'q35.2',
      end: 177100000,
      start: 173300001,
      stain: 'gpos25',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '5',
      end: 181538259,
      id: 'q35.3',
      stain: 'gneg',
      start: 177100001,
      assembly_name: 'GRCh38',
      strand: 0
    }],
    length: 181538259
  }, {
    coord_system: 'chromosome',
    bands: [{
      id: 'p11.1',
      end: 90900000,
      seq_region_name: '3',
      start: 87800001,
      stain: 'acen',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p11.2',
      end: 87800000,
      seq_region_name: '3',
      stain: 'gneg',
      start: 87100001
    }, {
      seq_region_name: '3',
      id: 'p12.1',
      end: 87100000,
      stain: 'gpos75',
      start: 83500001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '3',
      end: 83500000,
      id: 'p12.2',
      stain: 'gneg',
      start: 79800001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 74100001,
      stain: 'gpos75',
      seq_region_name: '3',
      id: 'p12.3',
      end: 79800000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 69700001,
      stain: 'gneg',
      seq_region_name: '3',
      end: 74100000,
      id: 'p13'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 63800001,
      stain: 'gpos50',
      seq_region_name: '3',
      end: 69700000,
      id: 'p14.1'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 58600001,
      seq_region_name: '3',
      end: 63800000,
      id: 'p14.2'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'p14.3',
      end: 58600000,
      seq_region_name: '3',
      stain: 'gpos50',
      start: 54400001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gneg',
      start: 52300001,
      end: 54400000,
      id: 'p21.1',
      seq_region_name: '3'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos25',
      start: 50600001,
      seq_region_name: '3',
      end: 52300000,
      id: 'p21.2'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 44200001,
      stain: 'gneg',
      id: 'p21.31',
      end: 50600000,
      seq_region_name: '3'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 44200000,
      id: 'p21.32',
      seq_region_name: '3',
      stain: 'gpos50',
      start: 44100001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      end: 44100000,
      id: 'p21.33',
      seq_region_name: '3',
      stain: 'gneg',
      start: 43600001
    }, {
      seq_region_name: '3',
      id: 'p22.1',
      end: 43600000,
      stain: 'gpos75',
      start: 39300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 36400001,
      stain: 'gneg',
      id: 'p22.2',
      end: 39300000,
      seq_region_name: '3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'p22.3',
      end: 36400000,
      seq_region_name: '3',
      start: 32000001,
      stain: 'gpos50',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '3',
      id: 'p23',
      end: 32000000,
      stain: 'gneg',
      start: 30800001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 26300001,
      stain: 'gpos75',
      seq_region_name: '3',
      id: 'p24.1',
      end: 30800000
    }, {
      end: 26300000,
      id: 'p24.2',
      seq_region_name: '3',
      start: 23800001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos100',
      start: 16300001,
      seq_region_name: '3',
      end: 23800000,
      id: 'p24.3'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '3',
      end: 16300000,
      id: 'p25.1',
      start: 13200001,
      stain: 'gneg'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'p25.2',
      end: 13200000,
      seq_region_name: '3',
      stain: 'gpos25',
      start: 11600001
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '3',
      end: 11600000,
      id: 'p25.3',
      stain: 'gneg',
      start: 8100001
    }, {
      seq_region_name: '3',
      end: 8100000,
      id: 'p26.1',
      stain: 'gpos50',
      start: 4000001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '3',
      end: 4000000,
      id: 'p26.2',
      start: 2800001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      id: 'p26.3',
      end: 2800000,
      seq_region_name: '3',
      stain: 'gpos50',
      start: 1,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 90900001,
      stain: 'acen',
      seq_region_name: '3',
      id: 'q11.1',
      end: 94000000,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q11.2',
      end: 98600000,
      seq_region_name: '3',
      start: 94000001,
      stain: 'gvar',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '3',
      end: 100300000,
      id: 'q12.1',
      stain: 'gneg',
      start: 98600001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      seq_region_name: '3',
      end: 101200000,
      id: 'q12.2',
      start: 100300001,
      stain: 'gpos25'
    }, {
      seq_region_name: '3',
      end: 103100000,
      id: 'q12.3',
      start: 101200001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      end: 106500000,
      id: 'q13.11',
      seq_region_name: '3',
      start: 103100001,
      stain: 'gpos75',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      start: 106500001,
      stain: 'gneg',
      id: 'q13.12',
      end: 108200000,
      seq_region_name: '3',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      start: 108200001,
      stain: 'gpos50',
      seq_region_name: '3',
      end: 111600000,
      id: 'q13.13',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      stain: 'gneg',
      start: 111600001,
      end: 113700000,
      id: 'q13.2',
      seq_region_name: '3',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 113700001,
      seq_region_name: '3',
      end: 117600000,
      id: 'q13.31'
    }, {
      stain: 'gneg',
      start: 117600001,
      seq_region_name: '3',
      id: 'q13.32',
      end: 119300000,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 119300001,
      stain: 'gpos75',
      seq_region_name: '3',
      id: 'q13.33',
      end: 122200000
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '3',
      end: 124100000,
      id: 'q21.1',
      stain: 'gneg',
      start: 122200001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gpos25',
      start: 124100001,
      seq_region_name: '3',
      id: 'q21.2',
      end: 126100000
    }, {
      id: 'q21.3',
      end: 129500000,
      seq_region_name: '3',
      stain: 'gneg',
      start: 126100001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 129500001,
      stain: 'gpos25',
      seq_region_name: '3',
      end: 134000000,
      id: 'q22.1'
    }, {
      seq_region_name: '3',
      id: 'q22.2',
      end: 136000000,
      start: 134000001,
      stain: 'gneg',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      seq_region_name: '3',
      end: 139000000,
      id: 'q22.3',
      start: 136000001,
      stain: 'gpos25',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      stain: 'gneg',
      start: 139000001,
      end: 143100000,
      id: 'q23',
      seq_region_name: '3'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      end: 149200000,
      id: 'q24',
      seq_region_name: '3',
      start: 143100001,
      stain: 'gpos100'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      id: 'q25.1',
      end: 152300000,
      seq_region_name: '3',
      stain: 'gneg',
      start: 149200001
    }, {
      end: 155300000,
      id: 'q25.2',
      seq_region_name: '3',
      stain: 'gpos50',
      start: 152300001,
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      seq_region_name: '3',
      id: 'q25.31',
      end: 157300000,
      stain: 'gneg',
      start: 155300001
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      id: 'q25.32',
      end: 159300000,
      seq_region_name: '3',
      start: 157300001,
      stain: 'gpos50'
    }, {
      end: 161000000,
      id: 'q25.33',
      seq_region_name: '3',
      stain: 'gneg',
      start: 159300001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      id: 'q26.1',
      end: 167900000,
      seq_region_name: '3',
      stain: 'gpos100',
      start: 161000001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      seq_region_name: '3',
      id: 'q26.2',
      end: 171200000,
      start: 167900001,
      stain: 'gneg',
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      stain: 'gpos75',
      start: 171200001,
      seq_region_name: '3',
      id: 'q26.31',
      end: 176000000
    }, {
      id: 'q26.32',
      end: 179300000,
      seq_region_name: '3',
      stain: 'gneg',
      start: 176000001,
      assembly_name: 'GRCh38',
      strand: 0
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 179300001,
      stain: 'gpos75',
      seq_region_name: '3',
      id: 'q26.33',
      end: 183000000
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 183000001,
      stain: 'gneg',
      end: 184800000,
      id: 'q27.1',
      seq_region_name: '3'
    }, {
      start: 184800001,
      stain: 'gpos25',
      seq_region_name: '3',
      end: 186300000,
      id: 'q27.2',
      strand: 0,
      assembly_name: 'GRCh38'
    }, {
      strand: 0,
      assembly_name: 'GRCh38',
      start: 186300001,
      stain: 'gneg',
      seq_region_name: '3',
      end: 188200000,
      id: 'q27.3'
    }, {
      assembly_name: 'GRCh38',
      strand: 0,
      start: 188200001,
      stain: 'gpos75',
      id: 'q28',
      end: 192600000,
      seq_region_name: '3'
    }, {
      stain: 'gneg',
      start: 192600001,
      end: 198295559,
      id: 'q29',
      seq_region_name: '3',
      strand: 0,
      assembly_name: 'GRCh38'
    }],
    length: 198295559,
    name: '3'
  }, { name: 'MT', length: 16569, coord_system: 'chromosome' }, { length: 448248, coord_system: 'scaffold', name: 'KI270727.1' }],
  base_pairs: 3609003417,
  golden_path: 3096649726,
  assembly_name: 'GRCh38.p12',
  genebuild_start_date: '2014-01-Ensembl',
  coord_system_versions: ['GRCh38', 'GRCh37', 'NCBI36', 'NCBI35', 'NCBI34'],
  assembly_accession: 'GCA_000001405.27',
  default_coord_system_version: 'GRCh38'
};